import React, {  useEffect, useState, useCallback, useRef  } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next";
import { ENDPOINT,CANVAS_SIZE } from "constants/variables";
import { useNavigate } from 'react-router-dom'; 
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { es } from 'date-fns/locale';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box'; 
import Button from '@mui/material/Button'; 
import Checkbox from '@mui/material/Checkbox'; 
import CircularProgress from '@mui/material/CircularProgress'; 
import DeleteIcon from '@mui/icons-material/Delete'; 
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Grid  from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton'; 
import MenuItem  from "@mui/material/MenuItem"; 
import SearchIcon from '@mui/icons-material/Search';
import SignatureCanvas from 'react-signature-canvas';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography'; 
import { NumericFormat } from 'components/utils/NumericFormat';
import "css/generalSettings.css";
import "css/customDialog.css";
import { successErrorAction,warningErrorAction } from "actions/ErrorActions"; 
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import FormCreateOrEditOptTras  from "pages/forms/editOrNewFormDI/FormOptTrasEdit";
import FormCreateOrEditOriTras  from "pages/forms/editOrNewFormDI/FormOriTrasEdit";
import FormCreateOrEditAutTras  from "pages/forms/editOrNewFormDI/FormAutTrasEdit";
import FormCreateOrEditDestTras from "pages/forms/editOrNewFormDI/FormDestTrasEdit";
import FormCreateOrEditAutDest  from "pages/forms/editOrNewFormDI/FormAutDestEdit";
import FormSearchCodeLers  from "pages/forms/editOrNewFormDI/FormSearchCodeLers";
import FormSearchDescriptions  from "pages/forms/editOrNewFormDI/FormSearchDescriptions";
import FormCreateOrEditRelTrans  from "pages/forms/editOrNewFormDI/FormRelTransEdit";
import FormCreateOrEditRespProd  from "pages/forms/editOrNewFormDI/FormRespProdEdit"; 
import SearchNTFilter  from "pages/forms/editOrNewFormDI/FormSearchNT"; 
 
const initialStateForm = {
  "id" : "",
  "ownformdi_id" : "", 
  "defaultStore_id":0, 
  "useraccount_id":0,

  "defaultformatnumber":1,
  "isFinished":false,
  "isScanned":false,
  "preiddoc_sheet" : "",
  "sufiddoc_sheet" : 0,
  "number_dt":"",
  "date_sheet":"",
  
  "formopttrasstore_id": 0,
  "opt_tras_store_id" : 0,
  "opt_tras_documnettype_id" : 1,
  "opt_tras_documentid" : "",
  "opt_tras_tradename" : "",
  "opt_tras_name" : "",
  "opt_tras_contactname" : "",
  "opt_tras_roadtype_id" :  74,
  "opt_tras_street" : "",
  "opt_tras_country_id":  1,
  "opt_tras_country_name": "",
  "opt_tras_province_id": 30,
  "opt_tras_province_name": "",
  "opt_tras_postalcode_id": 6911,
  "opt_tras_postalcode_code":"",
  "opt_tras_postalcode_name": "",
  "opt_tras_community_id":  6, 
  "opt_tras_community_name": "",
  "opt_tras_phone":"",
  "opt_tras_email":"",
  "opt_tras_nima":"",
  "opt_tras_cnae":"",
  "opt_tras_inscription":"",
  "opt_tras_opt":0,
  "opt_tras_licenseplate":"",
  "opt_tras_economicactivity":"",
 
  "formoritrasstore_id": 0,
  "ori_tras_store_id" : 0,
  "ori_tras_documnettype_id" :1,
  "ori_tras_documentid" : "",
  "ori_tras_tradename" : "",
  "ori_tras_name" : "",
  "ori_tras_contactname" : "",
  "ori_tras_roadtype_id" :  74,
  "ori_tras_street" : "",
  "ori_tras_country_id": 1,
  "ori_tras_country_name": "",
  "ori_tras_province_id": 30,
  "ori_tras_province_name": "",
  "ori_tras_postalcode_id": 6911,
  "ori_tras_postalcode_code": "",
  "ori_tras_postalcode_name": "",
  "ori_tras_community_id": 6,
  "ori_tras_community_name": "",
  "ori_tras_phone":"",
  "ori_tras_email":"",
  "ori_tras_nima":"",
  "ori_tras_cnae":"",
  "ori_tras_inscription":"",
  "ori_tras_opt":0,
  "ori_tras_licenseplate":"",
  "ori_tras_economicactivity":"",
  
  "aut_tras_store_id" : 0,
  "aut_tras_documnettype_id" : 1,
  "aut_tras_documentid" : "",
  "aut_tras_tradename" : "",
  "aut_tras_name" : "",
  "aut_tras_contactname" : "",
  "aut_tras_roadtype_id" : 74,
  "aut_tras_street" : "",
  "aut_tras_country_id": 1,
  "aut_tras_country_name": "",
  "aut_tras_province_id": 30,
  "aut_tras_province_name": "",
  "aut_tras_postalcode_id": 6911,
  "aut_tras_postalcode_code": "",
  "aut_tras_postalcode_name": "",
  "aut_tras_community_id": 6,
  "aut_tras_community_name": "",
  "aut_tras_phone":"",
  "aut_tras_email":"",
  "aut_tras_nima":"",
  "aut_tras_cnae":"",
  "aut_tras_inscription":"",
  "aut_tras_opt":0,
  "aut_tras_licenseplate":"",
  "aut_tras_economicactivity":"",
  
  "formdesttrasstore_id": 0,
  "dest_tras_store_id" : 0,
  "dest_tras_documnettype_id" :1,
  "dest_tras_documentid" : "",
  "dest_tras_tradename" : "",
  "dest_tras_name" : "",
  "dest_tras_contactname" : "",
  "dest_tras_roadtype_id" : 74,
  "dest_tras_street" : "",
  "dest_tras_country_id": 1,
  "dest_tras_country_name": "",
  "dest_tras_province_id": 30,
  "dest_tras_province_name": "",
  "dest_tras_postalcode_id":6911,
  "dest_tras_postalcode_code": "",
  "dest_tras_postalcode_name": "",
  "dest_tras_community_id": 6,
  "dest_tras_community_name": "",
  "dest_tras_phone":"",
  "dest_tras_email":"",
  "dest_tras_nima":"",
  "dest_tras_cnae":"",
  "dest_tras_inscription":"",
  "dest_tras_opt":0,
  "dest_tras_licenseplate":"",
  "dest_tras_economicactivity":"",
 
  "aut_dest_store_id" : 0,
  "aut_dest_documnettype_id" :1,
  "aut_dest_documentid" : "",
  "aut_dest_tradename" : "",
  "aut_dest_name" : "",
  "aut_dest_contactname" : "",
  "aut_dest_roadtype_id" : 74,
  "aut_dest_street" : "",
  "aut_dest_country_id": 1,
  "aut_dest_country_name":"",
  "aut_dest_province_id": 30,
  "aut_dest_province_name":"",
  "aut_dest_postalcode_id": 6911,
  "aut_dest_postalcode_code":"",
  "aut_dest_postalcode_name":"",
  "aut_dest_community_id": 6,
  "aut_dest_community_name":"",
  "aut_dest_phone":"",
  "aut_dest_email":"",
  "aut_dest_nima":"",
  "aut_dest_cnae":"",
  "aut_dest_inscription":"",
  "aut_dest_opt":0,
  "aut_dest_licenseplate":"",
  "aut_dest_economicactivity":"",

  "codeler_id" : 0,
  "codeler_code" : "",
  "codeler_namees" : "",
  "codeler_nameen" : "",
  "description_id" : 0,
  "description_code" : "",
  "description_namees" : "",
  "description_nameen" : "",
  
  "treatmenttypeorigin_id" : 0,
  "treatmenttypeorigin_code" : "",
  "treatmenttypeorigin_namees" : "",
  "treatmenttypeorigin_nameen" : "",
 
  "treatmenttypedestine_id" : 0,
  "treatmenttypedestine_code" : "",
  "treatmenttypedestine_namees" : "",
  "treatmenttypedestine_nameen" : "",
  
  "processtypepeorigin_id" : 0,
  "processtypepeorigin_code" : "",
  "processtypepeorigin_namees" : "",
  "processtypepeorigin_nameen" : "",

  "processtypedestine_id" : 0,
  "processtypedestine_code" : "",
  "processtypedestine_namees" : "",
  "processtypedestine_nameen" : "",
  
  "dangerousness_id" : 0,
  "dangerousness_namees" : "",
  "dangerousness_nameen" : "",

  "charac_danger" : "",
  "amount" : 0,

  "formreltransstore_id": 0,
  "rel_trans_store_id" : 0,
  "rel_trans_documnettype_id" : 0,
  "rel_trans_documentid" : "",
  "rel_trans_tradename" : "",
  "rel_trans_name" : "",
  "rel_trans_contactname" : "",
  "rel_trans_roadtype_id" : "",
  "rel_trans_street" : "",
  "rel_trans_country_id": 1,
  "rel_trans_country_name":"",
  "rel_trans_province_id": 30,
  "rel_trans_province_name":"",
  "rel_trans_postalcode_id": 6911,
  "rel_trans_postalcode_code":"",
  "rel_trans_postalcode_name":"",
  "rel_trans_community_id": 6,
  "rel_trans_community_name":"",
  "rel_trans_phone":"",
  "rel_trans_email":"",
  "rel_trans_nima":"",
  "rel_trans_cnae":"",
  "rel_trans_inscription":"",
  "rel_trans_opt":0,
  "rel_trans_licenseplate":"",
  "rel_trans_economicactivity":"",
   
  "formrespprodstore_id": 0,
  "resp_prod_store_id" : 0,
  "resp_prod_documnettype_id" : 0,
  "resp_prod_documentid" : "",
  "resp_prod_tradename" : "",
  "resp_prod_name" : "",
  "resp_prod_contactname" : "",
  "resp_prod_roadtype_id" : "",
  "resp_prod_street" : "",
  "resp_prod_country_id": 1,
  "resp_prod_country_name":"",
  "resp_prod_province_id": 30,
  "resp_prod_province_name":"",
  "resp_prod_postalcode_id": 6911,
  "resp_prod_postalcode_code":"",
  "resp_prod_postalcode_name":"",
  "resp_prod_community_id": 6,
  "resp_prod_community_name":"",
  "resp_prod_phone":"",
  "resp_prod_email":"",
  "resp_prod_nima":"",
  "resp_prod_cnae":"",
  "resp_prod_inscription":"",
  "resp_prod_opt":0,
  "resp_prod_licenseplate":"",
  "resp_prod_economicactivity":"",

  "deliver_date":"",
  "delivery_quantity":0,
  "accept":"",
  "date_accepted":"",
  "observations":"",
  "date_refund":"",
  "reason_refund":"",
  "action_refund":"",

  "opt_tras_shared":false,
  "ori_tras_shared":false,
  "aut_tras_shared":false,
  "dest_tras_shared":false,
  "aut_dest_shared":false,
  "rel_trans_shared":false,
  "resp_prod_shared":false,

  "sendbyemail_form_opt_tras":false,
  "sendbyemail_form_ori_tras":false,
  "sendbyemail_form_aut_tras":false,
  "sendbyemail_form_dest_tras":false,
  "sendbyemail_form_aut_dest":false,
  "sendbyemail_form_rel_trans":false,
  "sendbyemail_form_resp_prod":false,

  "signature_opt_tras":"",
  "signature_dest_tras":"",
  "signature_refund":""  ,
  "end_date_sheet":"",
  "widevalidity":false
};

const textAccepted=[
  {"id":1,"name":"Text_NOT_REPORTING"},
  {"id":2,"name":"Text_FORM_IsAccept"},
  {"id":3,"name":"Text_FORM_IsNotAccept"},
  {"id":4,"name":"Text_FORM_IsAnnulled"},
];
  
const initialDocumentTypesToSelect = [{
  "id": "",
  "name": "",
   "entitycode":"F"
}];

const initialTypesToSelect = [{
  "id": "",
  "namees": "",
  "nameen": ""
}];

const initialRDToSelect = [{
  "id": "",
  "code": "",
  "namees": "",
  "nameen": ""
}];
 
const initialNTToSelect = [{
    "id":0,
    "number_dt":""
}];

export const FormEditOrCreate = ({id, showModalFormSettings,typeOfList}) => {
  const {t,i18n} = useTranslation(['listDataForms']);
  const token = useSelector((state) => state.loginUser.token);  
  const roles = useSelector((state) => state.loginUser.roles);  
  const defaultStore = useSelector((state) => state.loginUser.defaultStore)
  const useraccount_id = useSelector((state) => state.loginUser.useraccount_id);  
  const defaulttypesdi = useSelector((state) => state.loginUser.defaulttypesdi);  
  const defaultsignature= useSelector((state) => state.loginUser.signature_default);  
 
  const DEFAULTTYPEOFDOCUMENT = useSelector((state) => state.formatDIUser.default_documenttype); 
  const DEFAULTROADTYE = useSelector((state) => state.formatDIUser.default_roadtype); 
  const DEFAULTCOUNTRY = useSelector((state) => state.formatDIUser.default_country); 
  const DEFAULTCOUNTRY_NAME = useSelector((state) => state.formatDIUser.default_country_name); 
  const DEFAULTPROVINCE = useSelector((state) => state.formatDIUser.default_province); 
  const DEFAULTPROVINCE_NAME = useSelector((state) => state.formatDIUser.default_province_name); 
  const DEFAULTPOSTALCODE_ID = useSelector((state) => state.formatDIUser.default_postalcode); 
  const DEFAULTPOSTALCODE_CODE = useSelector((state) => state.formatDIUser.default_postalcode_code); 
  const DEFAULTPOSTALCODE_NAME = useSelector((state) => state.formatDIUser.default_postalcode_name); 
  const DEFAULTCOMMUNITY = useSelector((state) => state.formatDIUser.default_community); 
  const DEFAULTCOMMUNITY_NAME = useSelector((state) => state.formatDIUser.default_community_name); 

  const opt_tras_view = useSelector((state) => state.formatDIUser.opt_tras_view); 
  const opt_tras_expand = useSelector((state) => state.formatDIUser.opt_tras_expand);
  const ori_tras_view = useSelector((state) => state.formatDIUser.ori_tras_view); 
  const ori_tras_expand = useSelector((state) => state.formatDIUser.ori_tras_expand);
  const aut_tras_view = useSelector((state) => state.formatDIUser.aut_tras_view); 
  const aut_tras_expand = useSelector((state) => state.formatDIUser.aut_tras_expand);
  const dest_tras_view = useSelector((state) => state.formatDIUser.dest_tras_view); 
  const dest_tras_expand = useSelector((state) => state.formatDIUser.dest_tras_expand);
  const aut_dest_view = useSelector((state) => state.formatDIUser.aut_dest_view); 
  const aut_dest_expand = useSelector((state) => state.formatDIUser.aut_dest_expand);
  const rel_trans_view = useSelector((state) => state.formatDIUser.rel_trans_view); 
  const rel_trans_expand = useSelector((state) => state.formatDIUser.rel_trans_expand);
  const resp_prod_view = useSelector((state) => state.formatDIUser.resp_prod_view); 
  const resp_prod_expand = useSelector((state) => state.formatDIUser.resp_prod_expand);
  const number_dt_view = useSelector((state) => state.formatDIUser.number_dt_view);
  const code_description_view = useSelector((state) => state.formatDIUser.code_description_view);
  const code_treatmenttype_origin_view = useSelector((state) => state.formatDIUser.code_treatmenttype_origin_view);
  const code_treatmenttype_destine_view = useSelector((state) => state.formatDIUser.code_treatmenttype_destine_view);
  const code_processtype_origin_view = useSelector((state) => state.formatDIUser.code_processtype_origin_view);
  const code_processtype_destine_view = useSelector((state) => state.formatDIUser.code_processtype_destine_view);
  const code_dangerousness_view = useSelector((state) => state.formatDIUser.code_dangerousness_view);
  const charac_danger_view = useSelector((state) => state.formatDIUser.charac_danger_view);
  const date_refund_view = useSelector((state) => state.formatDIUser.date_refund_view);
  const reason_refund_view = useSelector((state) => state.formatDIUser.reason_refund_view);
  const action_refund_view = useSelector((state) => state.formatDIUser.action_refund_view);
  const number_dt_handle = useSelector((state) => state.formatDIUser.number_dt_handle);
  const code_description_handle = useSelector((state) => state.formatDIUser.code_description_handle);
  const code_treatmenttype_origin_handle = useSelector((state) => state.formatDIUser.code_treatmenttype_origin_handle);
  const code_treatmenttype_destine_handle = useSelector((state) => state.formatDIUser.code_treatmenttype_destine_handle);
  const code_processtype_origin_handle = useSelector((state) => state.formatDIUser.code_processtype_origin_handle);
  const code_processtype_destine_handle = useSelector((state) => state.formatDIUser.code_processtype_destine_handle);
  const code_dangerousness_handle = useSelector((state) => state.formatDIUser.code_dangerousness_handle);
  const charac_danger_handle = useSelector((state) => state.formatDIUser.charac_danger_handle);
  const date_refund_handle = useSelector((state) => state.formatDIUser.date_refund_handle);
  const reason_refund_handle = useSelector((state) => state.formatDIUser.reason_refund_handle);
  const action_refund_handle = useSelector((state) => state.formatDIUser.action_refund_handle);
  const signature_default = useSelector((state) => state.formatDIUser.signature_default);
  const signature_default_des_tras = useSelector((state) => state.formatDIUser.signature_default_des_tras);

  const [formForm, setFormForm] = useState(initialStateForm);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [isLoadingErrorData, setIsLoadingErrorData] = useState(false);
  const [errorsForm, setErrorsForm] = useState({});
  const [hasbeenshared, setHasbeenshared] = useState(false);
  const [foundNumberOfDI, setFoundNumberOfDI ]= useState(false);
    
  const [sharedLicensePlate, setSharedLicensePlate] = useState(false);
  const [sharedAmount, setSharedAmount] = useState(false);
  const [shareddeliver_date, setShareddeliver_date] = useState(false);
  const [shareddate_accepted, setShareddate_accepted] = useState(false);
  const [sharedreason_refund, setSharedreason_refund] = useState(false);
  const [sharedaction_refund, setSharedaction_refund] = useState(false);
  const [shareddate_refund, setShareddate_refund] = useState(false);
  const [sharedobservations, setSharedobservations] = useState(false);
  const [sharedsignOptTras, setSharedsignOptTras] = useState(false);
  const [sharedsignDestTras, setSharedsignDestTras] = useState(false);
  const [sharedsignRefund, setSharedsignRefund] = useState(false);
  
  const [documentTypesToSelect,setDocumentTypesToSelect]= useState(initialDocumentTypesToSelect); 
  const [roadTypesToSelect,setRoadTypesToSelect]= useState(initialRDToSelect);
  const [optTypeToSelect,setOptTypeToSelect]= useState(initialRDToSelect);
  const [communityToSelect,setCommunityToSelect]= useState(initialRDToSelect);
  const [treatmenttypeToSelect,setTreatmenttypeToSelect]= useState(initialRDToSelect);
  const [processtypeToSelect,setProcesstypeToSelect]= useState(initialRDToSelect);
  const [dangerousness,setDangerousness]= useState(initialRDToSelect); 
  const [expanded, setExpanded] =  useState(false);
  const [showModalNTSettings, setShowModalNTSettings] =  useState(false);
  const [showModalSearchCodeLERS, setShowModalSearchCodeLERS] =  useState(false);
  const [showModalSearchDescriptions, setShowModalSearchDescriptions] =  useState(false);  
  const signDispatchedOptTrasCanvas = useRef(null);
  const signDispatchedDestTrasCanvas = useRef(null);
  const signDispatchedRefundCanvas = useRef(null);

  const [ntToSelect,setNtToSelect]= useState(initialNTToSelect);  
  const [filteredNT, setFilteredNT] = useState([]); // Opciones filtradas
  const [highlightedIndexNT, setHighlightedIndexNT] = useState(-1); // Índice de la opción resaltada 
       
  const dispatch = useDispatch();
  const navigate = useNavigate(); 
 
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && showModalFormSettings) {
       
        setFormForm(initialStateForm);
        setFormForm(formForm => ({
          ...formForm
        })); 
        setIsLoadingErrorData(false);
        setErrorsForm({});
        setDocumentTypesToSelect(initialDocumentTypesToSelect);
        setRoadTypesToSelect(initialRDToSelect);
        setCommunityToSelect(initialRDToSelect); 
        setOptTypeToSelect(initialRDToSelect);
        setTreatmenttypeToSelect(initialRDToSelect);
        setProcesstypeToSelect(initialRDToSelect);
        setDangerousness(initialTypesToSelect);
        setExpanded(false); 
        setShowModalSearchCodeLERS(false);
        setShowModalNTSettings(false);
        setShowModalSearchDescriptions(false);
        setHasbeenshared(false);
        setSharedLicensePlate(false);
        setSharedAmount(false);
        setShareddeliver_date(false); 
        setShareddate_accepted(false);
        setSharedreason_refund(false);
        setSharedaction_refund(false);
        setShareddate_refund(false);
        setSharedobservations(false);
        setSharedsignOptTras(false);
        setSharedsignDestTras(false);
        setSharedsignRefund(false);
        setFoundNumberOfDI(false);
        dispatch(setLoading(false));
        setNtToSelect(initialNTToSelect);
        setFilteredNT([]);
        setHighlightedIndexNT(-1);  

        if (signDispatchedOptTrasCanvas.current) signDispatchedOptTrasCanvas.current.clear();
        if (signDispatchedDestTrasCanvas.current) signDispatchedDestTrasCanvas.current.clear();
        if (signDispatchedRefundCanvas.current) signDispatchedRefundCanvas.current.clear();
        if (formForm.id!==undefined && formForm.id!=="" && formForm.id!=="0" && formForm.id!==0){
          navigate(typeOfList==="1"?"/formdi":"/formdiended") ;
        }else{
          navigate("/home"); 
        }
        return () => {};
      }
    },
    [
      setFormForm, 
      setIsLoadingErrorData,
      setErrorsForm,
      setDocumentTypesToSelect,
      setRoadTypesToSelect,
      setCommunityToSelect, 
      setOptTypeToSelect,
      setTreatmenttypeToSelect,
      setProcesstypeToSelect,
      setDangerousness,
      setExpanded,
      setShowModalNTSettings,
      setShowModalSearchCodeLERS,
      setShowModalSearchDescriptions,   
      setHasbeenshared,
      setSharedLicensePlate,
      setSharedAmount,
      setShareddeliver_date, 
      setShareddate_accepted,
      setSharedreason_refund,
      setSharedaction_refund,
      setShareddate_refund,
      setSharedobservations,
      setSharedsignOptTras,
      setSharedsignDestTras,
      setSharedsignRefund,
      setFoundNumberOfDI,
      setNtToSelect,
      setFilteredNT,
      setHighlightedIndexNT,  
      showModalFormSettings,
      navigate,
      typeOfList,
      dispatch,
      formForm.id]
  );
  
  const handleCloseDataEditForm = () => {
    
    setFormForm(initialStateForm);
    setFormForm(formForm => ({
      ...formForm 
    })); 
    setIsLoadingErrorData(false);
    setErrorsForm({});
    setDocumentTypesToSelect(initialDocumentTypesToSelect);
    setRoadTypesToSelect(initialRDToSelect);
    setCommunityToSelect(initialRDToSelect); 
    setOptTypeToSelect(initialRDToSelect);
    setTreatmenttypeToSelect(initialRDToSelect);
    setProcesstypeToSelect(initialRDToSelect);
    setDangerousness(initialTypesToSelect);
    setExpanded(false);
    setHasbeenshared(false);
    setSharedLicensePlate(false);
    setSharedAmount(false);
    setShareddeliver_date(false); 
    setShareddate_accepted(false);
    setSharedreason_refund(false);
    setSharedaction_refund(false);
    setShareddate_refund(false);
    setSharedobservations(false);
    setSharedsignOptTras(false);
    setSharedsignDestTras(false);
    setSharedsignRefund(false);
    setShowModalNTSettings(false);
    setShowModalSearchCodeLERS(false);
    setShowModalSearchDescriptions(false);    
    setFoundNumberOfDI(false);
    dispatch(setLoading(false));
    setNtToSelect(initialNTToSelect);
    setFilteredNT([]);
    setHighlightedIndexNT(-1);  
    if (signDispatchedOptTrasCanvas.current) signDispatchedOptTrasCanvas.current.clear();
    if (signDispatchedDestTrasCanvas.current) signDispatchedDestTrasCanvas.current.clear();
    if (signDispatchedRefundCanvas.current) signDispatchedRefundCanvas.current.clear();
    if (formForm.id!==undefined && formForm.id!=="" && formForm.id!=="0" && formForm.id!==0){
      navigate(typeOfList==="1"?"/formdi":"/formdiended") ;
    }else{
      navigate("/home"); 
    }
    return () => {};
	};
  
  // Debounce helper
  const useDebounce = (callback, delay = 300) => {
    const timeoutRef = useRef(null);
    return useCallback((...args) => {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
        callback(...args);
        }, delay);
    }, [callback, delay]);
  };
  // Dentro del componente
  const debouncedHandleSearchNT= useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
        setFilteredNT([]);
        setHighlightedIndexNT(-1);
      return;
    }
    const filtered = ntToSelect
      .filter(nt => nt && nt.number_dt)
      .filter(nt => {
        const number_dt = nt.number_dt.toUpperCase();
        return number_dt.startsWith(upperValue);
    })
    .slice(0, 20); // limitar resultados
    setFilteredNT(filtered);
    setHighlightedIndexNT(0);
  }, 300); 
  const handleSelectNT = (nt) => {
    if (!nt) return; // Validación adicional para evitar errores
    setFormForm((formForm) => ({
      ...formForm,
      number_dt: nt.number_dt || ""
    }));
    setFilteredNT([]);
    setHighlightedIndexNT(-1);
  }; 
  const handleKeyDownDNT = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredNT.length === 0 && formForm.number_dt.trim() === "") {
          const filtered = ntToSelect.filter(nt => nt && nt.number_dt).slice(0, 20);
          setFilteredNT(filtered);
          setHighlightedIndexNT(0);
      } else {
          setHighlightedIndexNT((prevIndex) => {
              const nextIndex = prevIndex < filteredNT.length - 1 ? prevIndex + 1 : prevIndex;
              scrollToElement(nextIndex);
              return nextIndex;
          });
      } 
    } else if (event.key === "ArrowUp") {
        setHighlightedIndexNT((prevIndex) => {
            const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
            // Desplaza al elemento anterior
            scrollToElement(prevIndexValid);
            return prevIndexValid;
        });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexNT >= 0) {
        if (highlightedIndexNT >= 0 && highlightedIndexNT < filteredNT.length) {
            handleSelectNT(filteredNT[highlightedIndexNT]);
        }
    } else if (event.key === "Escape") {
        const isValid = ntToSelect.some((nt) => {
            if (!nt || !nt.number_dt) return false; 
            const normalizedPostalCodeId = nt.number_dt.toUpperCase().replace(/[.-]/g, "");
            const normalizedInputId = formForm.number_dt.toUpperCase();
            return normalizedPostalCodeId === normalizedInputId;
        }); 
    if (!isValid) { 
        setFormForm((formForm) => ({
            ...formForm, 
            number_dt:  "" 
        }));
    } 
    setFilteredNT([]);
    setHighlightedIndexNT(-1);
    }
  };
  // Función para desplazar el contenedor
  const scrollToElement = (index) => {
      const dropdown = document.querySelector(".dropdown-class"); // Cambia por tu clase/ID
      const item = dropdown?.children[index];
      if (item) {
      item.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
      });
      }
  };
  const handleBlur = useCallback((event) => {
    if (!event || !event.currentTarget) return;
    // Asegúrate de que no se cierra si haces clic en un elemento de la lista
    if (!event.currentTarget.contains(event.relatedTarget)) {
        setFilteredNT([]);
        setHighlightedIndexNT(-1); 
    }
  }, []);
  
 const deleteSignature = (id) => {
    switch (id) {
      case 1:   
        if (signDispatchedOptTrasCanvas.current) signDispatchedOptTrasCanvas.current.clear();
        setFormForm(formForm => ({
          ...formForm,
          signature_opt_tras: "",
        })); 
        break;
      case 2:    
       if (signDispatchedDestTrasCanvas.current) signDispatchedDestTrasCanvas.current.clear();
        setFormForm(formForm => ({
          ...formForm,
          signature_dest_tras: "",
        }));
        break;
      case 3:    
      if (signDispatchedRefundCanvas.current) signDispatchedRefundCanvas.current.clear();
        setFormForm(formForm => ({
          ...formForm,
          signature_refund: "",
        }));
        break; 
      default:
        break;
    } 
  }; 

  const drawSignatureCentered = (canvasRef, base64) => {
    if (!canvasRef?.current || !base64) return;
    const canvas = canvasRef.current.getCanvas();
    const ctx = canvas.getContext("2d");
    // 🔒 Forzar tamaño interno fijo
    canvas.width = CANVAS_SIZE;
    canvas.height = CANVAS_SIZE;
    ctx.clearRect(0, 0, CANVAS_SIZE, CANVAS_SIZE);
    const img = new Image();
    img.src = base64;
    img.onload = () => {
      const imgWidth = img.width;
      const imgHeight = img.height;
      const scale = Math.min(
        CANVAS_SIZE / imgWidth,
        CANVAS_SIZE / imgHeight
      );
      const drawWidth = imgWidth * scale;
      const drawHeight = imgHeight * scale;
      const x = (CANVAS_SIZE - drawWidth) / 2;
      const y = (CANVAS_SIZE - drawHeight) / 2;
      ctx.drawImage(img, x, y, drawWidth, drawHeight);
    };
  };

  const drawPredefinedSignature = () => {
    if (!signDispatchedOptTrasCanvas.current) return;
    const canvasRef = signDispatchedOptTrasCanvas.current;
    const canvas = canvasRef.getCanvas();
    const ctx = canvas.getContext("2d");
    canvas.width = CANVAS_SIZE;
    canvas.height = CANVAS_SIZE;
    ctx.clearRect(0, 0, CANVAS_SIZE, CANVAS_SIZE);
    const img = new Image();
    img.src = defaultsignature;
    img.onload = () => {
      const imgWidth = img.width;
      const imgHeight = img.height;
      const scale = Math.min(
        CANVAS_SIZE / imgWidth,
        CANVAS_SIZE / imgHeight
      );
      const drawWidth = imgWidth * scale;
      const drawHeight = imgHeight * scale;
      const x = (CANVAS_SIZE - drawWidth) / 2;
      const y = (CANVAS_SIZE - drawHeight) / 2;
      ctx.drawImage(img, x, y, drawWidth, drawHeight);
      const base64 = canvasRef
        .getTrimmedCanvas()
        .toDataURL("image/png");
      setFormForm(formForm => ({
        ...formForm,
        signature_opt_tras: base64
      }));
    };
  };

  const drawPredefinedSignatureDestTras = () => {
    if (!signDispatchedDestTrasCanvas.current) return;
    const canvasRef = signDispatchedDestTrasCanvas.current;
    const canvas = canvasRef.getCanvas();
    const ctx = canvas.getContext("2d");
    canvas.width = CANVAS_SIZE;
    canvas.height = CANVAS_SIZE;
    ctx.clearRect(0, 0, CANVAS_SIZE, CANVAS_SIZE);
    const img = new Image();
    img.src = defaultsignature;
    img.onload = () => {
      const imgWidth = img.width;
      const imgHeight = img.height;
      const scale = Math.min(
        CANVAS_SIZE / imgWidth,
        CANVAS_SIZE / imgHeight
      );
      const drawWidth = imgWidth * scale;
      const drawHeight = imgHeight * scale;
      const x = (CANVAS_SIZE - drawWidth) / 2;
      const y = (CANVAS_SIZE - drawHeight) / 2;
      ctx.drawImage(img, x, y, drawWidth, drawHeight);
      const base64 = canvasRef
        .getTrimmedCanvas()
        .toDataURL("image/png");
      setFormForm(formForm => ({
        ...formForm,
        signature_dest_tras: base64
      }));
    };
  };

  const drawPredefinedSignatureRefund = () => {
    if (!signDispatchedRefundCanvas.current) return;
    const canvasRef = signDispatchedRefundCanvas.current;
    const canvas = canvasRef.getCanvas();
    const ctx = canvas.getContext("2d");
    canvas.width = CANVAS_SIZE;
    canvas.height = CANVAS_SIZE;
    ctx.clearRect(0, 0, CANVAS_SIZE, CANVAS_SIZE);
    const img = new Image();
    img.src = defaultsignature;
    img.onload = () => {
      const imgWidth = img.width;
      const imgHeight = img.height;
      const scale = Math.min(
        CANVAS_SIZE / imgWidth,
        CANVAS_SIZE / imgHeight
      );
      const drawWidth = imgWidth * scale;
      const drawHeight = imgHeight * scale;
      const x = (CANVAS_SIZE - drawWidth) / 2;
      const y = (CANVAS_SIZE - drawHeight) / 2;
      ctx.drawImage(img, x, y, drawWidth, drawHeight);
      const base64 = canvasRef
        .getTrimmedCanvas()
        .toDataURL("image/png");
      setFormForm(formForm => ({
        ...formForm,
        signature_refund: base64
      }));
    };
  };

  const handleChangeDataEditFormAmount = (e) => {
    const { name, value } = e.target;
    let newValue=value!==null?Number((value.toLocaleString()).replaceAll(",","").replaceAll(" kg","")):0;
    setFormForm(formForm => ({
      ...formForm,
      [name]: newValue,
    }));
    if (name === "delivery_quantity" && newValue > 0) {
      setErrorsForm(errors => ({...errors, delivery_quantity: undefined}));
    }
  };

  const handleBlurDataEditFormAmount = (e) => {
    handleChangeDataEditFormAmount(e);
    setErrorsForm(validateFormForm());
  };
    
  const handleChangeDataEditForm = (e) => {
    const { name, value } = e.target;
    setFormForm(formForm => ({
      ...formForm,
      [name]: value,
    }));
  };

  const handleBlurDataEditForm = (e) => {
    handleChangeDataEditForm(e);
    setErrorsForm(validateFormForm());
  };

   const handleChangeSelectDate = (event) => {
    setFormForm(prev => { 
      if (!event) {
        return {
          ...prev,
          date_sheet: null,
          end_date_sheet: null
        };
      } 
      const startDate = new Date(event);
      let endDate = new Date(startDate);
      // Si widevalidity está activo, sumamos 3 meses
      if (prev.widevalidity) {
        endDate.setMonth(endDate.getMonth() + 3);
      }
      return {
        ...prev,
        date_sheet: startDate,
        end_date_sheet: endDate
      };
    });
  }; 

  const handleBlurSelectDate = (e) => {
    handleChangeSelectDate(e);
    setErrorsForm(validateFormForm());
  };

  const handleChangeSelectEndDate = (event) => {
    setFormForm(formForm => ({
      ...formForm,
      end_date_sheet:event!==null?new Date(event):null
    }));
  };

  const handleBlurSelectEndDate = (e) => {
    handleChangeSelectEndDate(e);
    setErrorsForm(validateFormForm());
  };

  const handleChangeWideValidity = () => {
    setFormForm(prev => { 
      let endDate = null; 
      if (prev.date_sheet) {
        endDate = new Date(prev.date_sheet); 
        if (!prev.widevalidity) {
          endDate.setMonth(endDate.getMonth() + 3);
        }
      }
      return {
        ...prev,
        widevalidity: !prev.widevalidity,
        end_date_sheet: endDate
      };
    });
  };

  const deleteDataCodeLer = (event) => {
    setFormForm(formForm => ({
      ...formForm,
      codeler_id:0,
      codeler_code: "",
      codeler_namees:"",
      codeler_nameen: ""
    }));
  };

  const searchFormNTs = (event) => {
    setShowModalNTSettings(true);
  };

  const searchFormCodeLer = (event) => {
    setShowModalSearchCodeLERS(true);
  };

  const deleteDataDescription = (event) => {
    setFormForm(formForm => ({
      ...formForm,
      description_id:0,
      description_code: "",
      description_namees:"",
      description_nameen: ""
    }));
  };

  const searchFormDescription = (event) => {
    setShowModalSearchDescriptions(true);
  };

  const withValueCap = (inputObj) => {
    const { value } = inputObj;
    if (value <= 100000000000) return true;
    return false;
  };

  const handleChangeSelectDateDeliver = (event) => {
    setFormForm(formForm => ({
      ...formForm,
      deliver_date: event!==null?new Date(event):null
    }));
    if (event !== null) {
      setErrorsForm(errors => ({...errors, deliver_date: undefined}));
    }
  };

  const handleBlurSelectDateDeliver = () => setErrorsForm(validateFormForm());

  const handleChangeSelectDateAccepted = (event) => {
    setFormForm(formForm => ({
      ...formForm,
      date_accepted: event!==null?new Date(event):null
    }));
    if (event !== null) {
      setErrorsForm(errors => ({...errors, date_accepted: undefined}));
    }
  };

  const handleBlurSelectDateAccepted = () => setErrorsForm(validateFormForm());

  const handleChangeSelectDateRefund = (event) => {
    setFormForm(formForm => ({
      ...formForm,
      date_refund: event!==null?new Date(event):null
    }));
    if (event !== null) {
      setErrorsForm(errors => ({...errors, date_refund: undefined}));
    }
  };

  const handleBlurSelectDateRefund = () => setErrorsForm(validateFormForm());
  
  const handleChangeSelectAccepted = (event) => {
    setFormForm(formForm => ({
        ...formForm,
        accept : event.target.value 
    }));
  };

  const handleBlurSelectAccepted = (e) => {
      handleChangeSelectAccepted(e);
      setErrorsForm(validateFormForm());
  };

  const handleChangeSelectTreatmentTypeOrigin = (event) => {
    setFormForm(formForm => ({
      ...formForm,
      treatmenttypeorigin_id:event.target.value
    }));
  };

  const handleBlurSelectTreatmentTypeOrigin = (e) => {
    handleChangeSelectTreatmentTypeOrigin(e);
  };

  const handleChangeSelectTreatmentTypeDestine = (event) => {
    setFormForm(formForm => ({
      ...formForm,
      treatmenttypedestine_id:event.target.value

    }));
  };

  const handleBlurSelectTreatmentTypeDestine = (e) => {
    handleChangeSelectTreatmentTypeDestine(e);
  };

  const handleChangeSelectProcessTypeOrigin = (event) => {
    setFormForm(formForm => ({
      ...formForm,
      processtypepeorigin_id:event.target.value
    }));
  };

  const handleBlurSelectProcessTypeOrigin = (e) => {
    handleChangeSelectProcessTypeOrigin(e);
  };

  const handleChangeSelectProcessTypeDestine = (event) => {
    setFormForm(formForm => ({
      ...formForm,
      processtypedestine_id:event.target.value
    }));
  };

  const handleBlurSelectProcessTypeDestine = (e) => {
    handleChangeSelectProcessTypeDestine(e);
  };

  const handleChangeSelectDangerousness = (event) => {
    setFormForm(formForm => ({
      ...formForm,
      dangerousness_id:event.target.value
    }));
  };

  const handleBlurSelectDangerousness = (e) => {
    handleChangeSelectDangerousness(e);
  };

  const validateFormForm = () => {
    let errorsForm = {};
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;
    const isAccepted = formForm.accept === "Text_FORM_IsAccept";
    const isRejected = formForm.accept === "Text_FORM_IsNotAccept";
    const hasReceptionResult = isAccepted || isRejected;
     
    if (!formForm.preiddoc_sheet || formForm.preiddoc_sheet==="") {
      errorsForm.preiddoc_sheet = 'Text_Field_Preiddoc_Sheet_Required'; 
    } else {
      if (regexInvalidCharacters.test(formForm.preiddoc_sheet)) {
        errorsForm.preiddoc_sheet = 'Text_TextNoValid';
      }
    }    
    if (foundNumberOfDI){
      errorsForm.sufiddoc_sheet='Text_FieldnumberdiExist';
    }  
    if (regexInvalidCharacters.test(formForm.number_dt)) {
      errorsForm.number_dt = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formForm.opt_tras_documentid)) {
      errorsForm.opt_tras_documentid = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.opt_tras_tradename)) {
      errorsForm.opt_tras_tradename = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.opt_tras_name)) {
      errorsForm.opt_tras_name = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.opt_tras_contactname)) {
      errorsForm.opt_tras_contactname = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.opt_tras_street)) {
      errorsForm.opt_tras_street = 'Text_TextNoValid';
    }
     if (regexInvalidCharacters.test(formForm.opt_tras_postalcode_code)) {
      errorsForm.opt_tras_postalcode_code = 'Text_TextNoValid';
    }else{
      if (formForm.opt_tras_documentid!=="" && formForm.opt_tras_street!==""){
        if (formForm.opt_tras_postalcode_code===undefined || formForm.opt_tras_postalcode_code===null || formForm.opt_tras_postalcode_code===""){
          errorsForm.opt_tras_postalcode_code='Text_Field_POSTALCODE_Opt_Tras_Required';
        }
      }
    }
    if (regexInvalidCharacters.test(formForm.ori_tras_postalcode_code)) {
      errorsForm.ori_tras_postalcode_code = 'Text_TextNoValid';
    }else{
      if (formForm.ori_tras_documentid!=="" && formForm.ori_tras_street!==""){
        if (formForm.ori_tras_postalcode_code===undefined || formForm.ori_tras_postalcode_code===null || formForm.ori_tras_postalcode_code===""){
          errorsForm.ori_tras_postalcode_code='Text_Field_POSTALCODE_Ori_Tras_Required';
        }
      }
    }
    if (regexInvalidCharacters.test(formForm.aut_tras_postalcode_code)) {
      errorsForm.aut_tras_postalcode_code = 'Text_TextNoValid';
    }else{
      if (formForm.aut_tras_documentid!=="" && formForm.aut_tras_street!==""){
        if (formForm.aut_tras_postalcode_code===undefined || formForm.aut_tras_postalcode_code===null || formForm.aut_tras_postalcode_code===""){
          errorsForm.aut_tras_postalcode_code='Text_Field_POSTALCODE_Aut_Tras_Required';
        }
      }
    }
    if (regexInvalidCharacters.test(formForm.dest_tras_postalcode_code)) {
      errorsForm.dest_tras_postalcode_code = 'Text_TextNoValid';
    }else{
      if (formForm.dest_tras_documentid!=="" && formForm.dest_tras_street!==""){
        if (formForm.dest_tras_postalcode_code===undefined || formForm.dest_tras_postalcode_code===null || formForm.dest_tras_postalcode_code===""){
          errorsForm.dest_tras_postalcode_code='Text_Field_POSTALCODE_Dest_Tras_Required';
        }
      }
    }
    if (regexInvalidCharacters.test(formForm.aut_dest_postalcode_code)) {
      errorsForm.aut_dest_postalcode_code = 'Text_TextNoValid';
    }else{
      if (formForm.aut_dest_documentid!=="" && formForm.aut_dest_street!==""){
        if (formForm.aut_dest_postalcode_code===undefined || formForm.aut_dest_postalcode_code===null || formForm.aut_dest_postalcode_code===""){
          errorsForm.aut_dest_postalcode_code='Text_Field_POSTALCODE_Aut_Dest_Required';
        }
      }
    }
    if (regexInvalidCharacters.test(formForm.rel_trans_postalcode_code)) {
      errorsForm.rel_trans_postalcode_code = 'Text_TextNoValid';
    }else{
      if (formForm.rel_trans_documentid!=="" && formForm.rel_trans_street!==""){
        if (formForm.rel_trans_postalcode_code===undefined || formForm.rel_trans_postalcode_code===null || formForm.rel_trans_postalcode_code===""){
          errorsForm.rel_trans_postalcode_code='Text_Field_POSTALCODE_Rel_Trans_Required';
        }
      }
    }
   if (regexInvalidCharacters.test(formForm.resp_prod_postalcode_code)) {
      errorsForm.resp_prod_postalcode_code = 'Text_TextNoValid';
    }else{
      if (formForm.resp_prod_documentid!=="" && formForm.resp_prod_street!==""){
        if (formForm.resp_prod_postalcode_code===undefined || formForm.resp_prod_postalcode_code===null || formForm.resp_prod_postalcode_code===""){
          errorsForm.resp_prod_postalcode_code='Text_Field_POSTALCODE_Resp_Prod_Required';
        }
      }
    } 
    
    if (regexInvalidCharacters.test(formForm.opt_tras_phone)) {
      errorsForm.opt_tras_phone = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.opt_tras_email)) {
      errorsForm.opt_tras_email = 'Text_TextNoValid';
    } 
    if (!formForm.opt_tras_nima || formForm.opt_tras_nima==="") {
      errorsForm.opt_tras_nima = 'Text_Field_NIMA_Opt_Tras_Required'; 
    } else {
      if (regexInvalidCharacters.test(formForm.opt_tras_nima)) {
        errorsForm.opt_tras_nima = 'Text_TextNoValid';
      }
    } 
    if (regexInvalidCharacters.test(formForm.opt_tras_cnae)) {
      errorsForm.opt_tras_cnae = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.opt_tras_inscription)) {
      errorsForm.opt_tras_inscription = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formForm.opt_tras_licenseplate)) {
      errorsForm.opt_tras_licenseplate = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.opt_tras_economicactivity)) {
      errorsForm.opt_tras_economicactivity = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.ori_tras_documentid)) {
      errorsForm.ori_tras_documentid = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.ori_tras_tradename)) {
      errorsForm.ori_tras_tradename = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.ori_tras_name)) {
      errorsForm.ori_tras_name = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.ori_tras_contactname)) {
      errorsForm.ori_tras_contactname = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.ori_tras_street)) {
      errorsForm.ori_tras_street = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.ori_tras_phone)) {
      errorsForm.ori_tras_phone = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.ori_tras_email)) {
      errorsForm.ori_tras_email = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formForm.ori_tras_nima)) {
      errorsForm.ori_tras_nima = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.ori_tras_cnae)) {
      errorsForm.ori_tras_cnae = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.ori_tras_inscription)) {
      errorsForm.ori_tras_inscription = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formForm.ori_tras_licenseplate)) {
      errorsForm.ori_tras_licenseplate = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.ori_tras_economicactivity)) {
      errorsForm.ori_tras_economicactivity = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.aut_tras_documentid)) {
      errorsForm.aut_tras_documentid = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.aut_tras_tradename)) {
      errorsForm.aut_tras_tradename = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.aut_tras_name)) {
      errorsForm.aut_tras_name = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.aut_tras_contactname)) {
      errorsForm.aut_tras_contactname = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.aut_tras_street)) {
      errorsForm.aut_tras_street = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.aut_tras_phone)) {
      errorsForm.aut_tras_phone = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.aut_tras_email)) {
      errorsForm.aut_tras_email = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formForm.aut_tras_nima)) {
      errorsForm.aut_tras_nima = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.aut_tras_cnae)) {
      errorsForm.aut_tras_cnae = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.aut_tras_inscription)) {
      errorsForm.aut_tras_inscription = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formForm.aut_tras_licenseplate)) {
      errorsForm.aut_tras_licenseplate = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.aut_tras_economicactivity)) {
      errorsForm.aut_tras_economicactivity = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formForm.dest_tras_documentid)) {
      errorsForm.dest_tras_documentid = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.dest_tras_tradename)) {
      errorsForm.dest_tras_tradename = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.dest_tras_name)) {
      errorsForm.dest_tras_name = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.dest_tras_contactname)) {
      errorsForm.dest_tras_contactname = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.dest_tras_street)) {
      errorsForm.dest_tras_street = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.dest_tras_phone)) {
      errorsForm.dest_tras_phone = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.dest_tras_email)) {
      errorsForm.dest_tras_email = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formForm.dest_tras_nima)) {
      errorsForm.dest_tras_nima = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.dest_tras_cnae)) {
      errorsForm.dest_tras_cnae = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.dest_tras_inscription)) {
      errorsForm.dest_tras_inscription = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formForm.dest_tras_licenseplate)) {
      errorsForm.dest_tras_licenseplate = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.dest_tras_economicactivity)) {
      errorsForm.dest_tras_economicactivity = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.aut_dest_documentid)) {
      errorsForm.aut_dest_documentid = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.aut_dest_tradename)) {
      errorsForm.aut_dest_tradename = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.aut_dest_name)) {
      errorsForm.aut_dest_name = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.aut_dest_contactname)) {
      errorsForm.aut_dest_contactname = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.aut_dest_street)) {
      errorsForm.aut_dest_street = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.aut_dest_phone)) {
      errorsForm.aut_dest_phone = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.aut_dest_email)) {
      errorsForm.aut_dest_email = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formForm.aut_dest_nima)) {
      errorsForm.aut_dest_nima = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.aut_dest_cnae)) {
      errorsForm.aut_dest_cnae = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.aut_dest_inscription)) {
      errorsForm.aut_dest_inscription = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formForm.aut_dest_licenseplate)) {
      errorsForm.aut_dest_licenseplate = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.aut_dest_economicactivity)) {
      errorsForm.aut_dest_economicactivity = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.rel_trans_documentid)) {
      errorsForm.rel_trans_documentid = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.rel_trans_tradename)) {
      errorsForm.rel_trans_tradename = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.rel_trans_name)) {
      errorsForm.rel_trans_name = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.rel_trans_contactname)) {
      errorsForm.rel_trans_contactname = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.rel_trans_street)) {
      errorsForm.rel_trans_street = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.rel_trans_phone)) {
      errorsForm.rel_trans_phone = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.rel_trans_email)) {
      errorsForm.rel_trans_email = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formForm.rel_trans_nima)) {
      errorsForm.rel_trans_nima = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.rel_trans_cnae)) {
      errorsForm.rel_trans_cnae = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.rel_trans_inscription)) {
      errorsForm.rel_trans_inscription = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formForm.rel_trans_licenseplate)) {
      errorsForm.rel_trans_licenseplate = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.rel_trans_economicactivity)) {
      errorsForm.rel_trans_economicactivity = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.resp_prod_documentid)) {
      errorsForm.resp_prod_documentid = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.resp_prod_tradename)) {
      errorsForm.resp_prod_tradename = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.resp_prod_name)) {
      errorsForm.resp_prod_name = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.resp_prod_contactname)) {
      errorsForm.resp_prod_contactname = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.resp_prod_street)) {
      errorsForm.resp_prod_street = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.resp_prod_phone)) {
      errorsForm.resp_prod_phone = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.resp_prod_email)) {
      errorsForm.resp_prod_email = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formForm.resp_prod_nima)) {
      errorsForm.resp_prod_nima = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.resp_prod_cnae)) {
      errorsForm.resp_prod_cnae = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.resp_prod_inscription)) {
      errorsForm.resp_prod_inscription = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.resp_prod_licenseplate)) {
      errorsForm.resp_prod_licenseplate = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.resp_prod_economicactivity)) {
      errorsForm.resp_prod_economicactivity = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.codeler_code)) {
      errorsForm.codeler_code = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.description_code)) {
      errorsForm.description_code = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.charac_danger)) {
      errorsForm.charac_danger = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formForm.observations)) {
      errorsForm.observations = 'Text_TextNoValid';
    }
    if (hasReceptionResult && !formForm.deliver_date) {
      errorsForm.deliver_date = 'Text_ESIR_DeliveryDate_Required';
    }
    if (hasReceptionResult && (formForm.delivery_quantity === null
        || formForm.delivery_quantity === undefined
        || formForm.delivery_quantity === ""
        || Number(formForm.delivery_quantity) <= 0)) {
      errorsForm.delivery_quantity = 'Text_ESIR_RealQuantity_Required';
    }
    if (hasReceptionResult && !formForm.date_accepted) {
      errorsForm.date_accepted = 'Text_ESIR_AcceptanceDate_Required';
    }
    if (isRejected && (!formForm.reason_refund || formForm.reason_refund.trim() === "")) {
      errorsForm.reason_refund = 'Text_ESIR_RejectionFields_Required';
    } else if (regexInvalidCharacters.test(formForm.reason_refund)) {
      errorsForm.reason_refund = 'Text_TextNoValid';
    }
    if (isRejected && (!formForm.action_refund || formForm.action_refund.trim() === "")) {
      errorsForm.action_refund = 'Text_ESIR_RejectionFields_Required';
    } else if (regexInvalidCharacters.test(formForm.action_refund)) {
      errorsForm.action_refund = 'Text_TextNoValid';
    }
    if (isRejected && !formForm.date_refund) {
      errorsForm.date_refund = 'Text_ESIR_RejectionFields_Required';
    }
    return errorsForm;
  };

  const handleConfirmFetchDataEditForm = (dataToSend) => {  
    const fetchData = async () => { 
      try {
        const getData = id !== "0"
          ? await helpHttp().put(ENDPOINT, `form/updateformdi`, token, dataToSend)
          : await helpHttp().post(ENDPOINT, `form/saveformdi`, token, dataToSend);
        if (getData.status === "OK") {
          dispatch(successErrorAction(t('Text_SaveData')));
          const canAutoDeca = (roles ?? [])
            .flatMap((role) => role?.listmenus ?? [])
            .some((menu) => menu.name === 'SubMenu_Form_DECA');
          if (!canAutoDeca) return;
          const formdiId = getData.response?.id || dataToSend?.id;
          if (!formdiId) {
            dispatch(warningErrorAction(t('Text_DeCA_AutomaticError')));
            return;
          }
          try {
            let decaData = { status: "ACCEPTED" };
            for (let attempt = 0;
              decaData.status === "ACCEPTED" && attempt < 120;
              attempt += 1) {
              await new Promise((resolve) => setTimeout(resolve, 1000));
              decaData = await helpHttp().get(
                ENDPOINT,
                `form/generatedeca/status/${formdiId}`,
                token
              );
            } 
          } catch (decaError) {
            dispatch(warningErrorAction(t('Text_DeCA_AutomaticError')));
          }
        } else {
          dispatch(warningErrorAction(t(getData.cause)));
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };
    fetchData();
    handleCloseDataEditForm();
    return () => {};
  };
 
  const handleSubmitDataEditForm = () => {
    const errors = validateFormForm();
    setErrorsForm(errors);
    if (Object.keys(errors).length === 0 && formForm.preiddoc_sheet !== '') {

      let signatureOpt_tras = formForm.signature_opt_tras;
      let signatureDest_tras = formForm.signature_dest_tras;
      let signature_refund = formForm.signature_refund;
     
      if (signDispatchedOptTrasCanvas.current && !signDispatchedOptTrasCanvas.current.isEmpty()) {
        signatureOpt_tras = signDispatchedOptTrasCanvas.current.getTrimmedCanvas().toDataURL("image/png");
      }

      if (signDispatchedDestTrasCanvas.current && !signDispatchedDestTrasCanvas.current.isEmpty()) {
        signatureDest_tras = signDispatchedDestTrasCanvas.current.getTrimmedCanvas().toDataURL("image/png");
      }
      if (signDispatchedRefundCanvas.current && !signDispatchedRefundCanvas.current.isEmpty()) {
        signature_refund = signDispatchedRefundCanvas.current.getTrimmedCanvas().toDataURL("image/png");
      }
      const formToSend = {
        ...formForm,
        signature_opt_tras: signatureOpt_tras,
        signature_dest_tras: signatureDest_tras,
        signature_refund: signature_refund
      };
      
      setFormForm(formForm => ({
        ...formForm,
        signature_opt_tras: signatureOpt_tras,
        signature_dest_tras: signatureDest_tras,
        signature_refund: signature_refund
      }));

      handleConfirmFetchDataEditForm(formToSend); 
    } else {
      if (errors.preiddoc_sheet) {
        dispatch(warningErrorAction(t(errors.preiddoc_sheet)));
      } else if (errors.sufiddoc_sheet) {
        dispatch(warningErrorAction(t(errors.sufiddoc_sheet)));
      } else if (errors.number_dt) {
        dispatch(warningErrorAction(t(errors.number_dt)));
      } else if (errors.opt_tras_documentid) {
        dispatch(warningErrorAction(t(errors.opt_tras_documentid)));
      } else if (errors.opt_tras_tradename) {
        dispatch(warningErrorAction(t(errors.opt_tras_tradename)));
      } else if (errors.opt_tras_name) {
        dispatch(warningErrorAction(t(errors.opt_tras_name)));
      } else if (errors.opt_tras_contactname) {
        dispatch(warningErrorAction(t(errors.opt_tras_contactname)));
      } else if (errors.opt_tras_street) {
        dispatch(warningErrorAction(t(errors.opt_tras_street)));
        } else if (errors.opt_tras_postalcode_code) {
          dispatch(warningErrorAction(t(errors.opt_tras_postalcode_code)));
      } else if (errors.opt_tras_phone) {
        dispatch(warningErrorAction(t(errors.opt_tras_phone)));
      } else if (errors.opt_tras_email) {
        dispatch(warningErrorAction(t(errors.opt_tras_email)));
      } else if (errors.opt_tras_nima) {
        dispatch(warningErrorAction(t(errors.opt_tras_nima)));
      } else if (errors.opt_tras_cnae) {
        dispatch(warningErrorAction(t(errors.opt_tras_cnae)));
      } else if (errors.opt_tras_inscription) {
        dispatch(warningErrorAction(t(errors.opt_tras_inscription)));
      } else if (errors.opt_tras_licenseplate) {
        dispatch(warningErrorAction(t(errors.opt_tras_licenseplate)));
      } else if (errors.opt_tras_economicactivity) {
        dispatch(warningErrorAction(t(errors.opt_tras_economicactivity)));
      } else if (errors.ori_tras_documentid) {
        dispatch(warningErrorAction(t(errors.ori_tras_documentid)));
      } else if (errors.ori_tras_tradename) {
        dispatch(warningErrorAction(t(errors.ori_tras_tradename)));
      } else if (errors.ori_tras_name) {
        dispatch(warningErrorAction(t(errors.ori_tras_name)));
      } else if (errors.ori_tras_contactname) {
        dispatch(warningErrorAction(t(errors.ori_tras_contactname)));
      } else if (errors.ori_tras_street) {
        dispatch(warningErrorAction(t(errors.ori_tras_street)));
      } else if (errors.ori_tras_postalcode_code) {
          dispatch(warningErrorAction(t(errors.ori_tras_postalcode_code)));
      } else if (errors.ori_tras_phone) {
        dispatch(warningErrorAction(t(errors.ori_tras_phone)));
      } else if (errors.ori_tras_email) {
        dispatch(warningErrorAction(t(errors.ori_tras_email)));
      } else if (errors.ori_tras_nima) {
        dispatch(warningErrorAction(t(errors.ori_tras_nima)));
      } else if (errors.ori_tras_cnae) {
        dispatch(warningErrorAction(t(errors.ori_tras_cnae)));
      } else if (errors.ori_tras_inscription) {
        dispatch(warningErrorAction(t(errors.ori_tras_inscription)));
      } else if (errors.ori_tras_licenseplate) {
        dispatch(warningErrorAction(t(errors.ori_tras_licenseplate)));
      } else if (errors.ori_tras_economicactivity) {
        dispatch(warningErrorAction(t(errors.ori_tras_economicactivity)));
      } else if (errors.aut_tras_documentid) {
        dispatch(warningErrorAction(t(errors.aut_tras_documentid)));
      } else if (errors.aut_tras_tradename) {
        dispatch(warningErrorAction(t(errors.aut_tras_tradename)));
      } else if (errors.aut_tras_name) {
        dispatch(warningErrorAction(t(errors.aut_tras_name)));
      } else if (errors.aut_tras_contactname) {
        dispatch(warningErrorAction(t(errors.aut_tras_contactname)));
      } else if (errors.aut_tras_street) {
        dispatch(warningErrorAction(t(errors.aut_tras_street)));
      } else if (errors.aut_tras_postalcode_code) {
          dispatch(warningErrorAction(t(errors.aut_tras_postalcode_code)));
      } else if (errors.aut_tras_phone) {
        dispatch(warningErrorAction(t(errors.aut_tras_phone)));
      } else if (errors.aut_tras_email) {
        dispatch(warningErrorAction(t(errors.aut_tras_email)));
      } else if (errors.aut_tras_nima) {
        dispatch(warningErrorAction(t(errors.aut_tras_nima)));
      } else if (errors.aut_tras_cnae) {
        dispatch(warningErrorAction(t(errors.aut_tras_cnae)));
      } else if (errors.aut_tras_inscription) {
        dispatch(warningErrorAction(t(errors.aut_tras_inscription)));
      } else if (errors.aut_tras_licenseplate) {
        dispatch(warningErrorAction(t(errors.aut_tras_licenseplate)));
      } else if (errors.aut_tras_economicactivity) {
        dispatch(warningErrorAction(t(errors.aut_tras_economicactivity)));
      } else if (errors.dest_tras_documentid) {
        dispatch(warningErrorAction(t(errors.dest_tras_documentid)));
      } else if (errors.dest_tras_tradename) {
        dispatch(warningErrorAction(t(errors.dest_tras_tradename)));
      } else if (errors.dest_tras_name) {
        dispatch(warningErrorAction(t(errors.dest_tras_name)));
      } else if (errors.dest_tras_contactname) {
        dispatch(warningErrorAction(t(errors.dest_tras_contactname)));
      } else if (errors.dest_tras_street) {
        dispatch(warningErrorAction(t(errors.dest_tras_street)));
      } else if (errors.dest_tras_postalcode_code) {
          dispatch(warningErrorAction(t(errors.dest_tras_postalcode_code)));
      } else if (errors.dest_tras_phone) {
        dispatch(warningErrorAction(t(errors.dest_tras_phone)));
      } else if (errors.dest_tras_email) {
        dispatch(warningErrorAction(t(errors.dest_tras_email)));
      } else if (errors.dest_tras_nima) {
        dispatch(warningErrorAction(t(errors.dest_tras_nima)));
      } else if (errors.dest_tras_cnae) {
        dispatch(warningErrorAction(t(errors.dest_tras_cnae)));
      } else if (errors.dest_tras_inscription) {
        dispatch(warningErrorAction(t(errors.dest_tras_inscription)));
      } else if (errors.dest_tras_licenseplate) {
        dispatch(warningErrorAction(t(errors.dest_tras_licenseplate)));
      } else if (errors.dest_tras_economicactivity) {
        dispatch(warningErrorAction(t(errors.dest_tras_economicactivity)));
      } else if (errors.aut_dest_documentid) {
        dispatch(warningErrorAction(t(errors.aut_dest_documentid)));
      } else if (errors.aut_dest_tradename) {
        dispatch(warningErrorAction(t(errors.aut_dest_tradename)));
      } else if (errors.aut_dest_name) {
        dispatch(warningErrorAction(t(errors.aut_dest_name)));
      } else if (errors.aut_dest_contactname) {
        dispatch(warningErrorAction(t(errors.aut_dest_contactname)));
      } else if (errors.aut_dest_street) {
        dispatch(warningErrorAction(t(errors.aut_dest_street)));
      } else if (errors.aut_dest_postalcode_code) {
        dispatch(warningErrorAction(t(errors.aut_dest_postalcode_code)));
      } else if (errors.aut_dest_phone) {
        dispatch(warningErrorAction(t(errors.aut_dest_phone)));
      } else if (errors.aut_dest_email) {
        dispatch(warningErrorAction(t(errors.aut_dest_email)));
      } else if (errors.aut_dest_nima) {
        dispatch(warningErrorAction(t(errors.aut_dest_nima)));
      } else if (errors.aut_dest_cnae) {
        dispatch(warningErrorAction(t(errors.aut_dest_cnae)));
      } else if (errors.aut_dest_inscription) {
        dispatch(warningErrorAction(t(errors.aut_dest_inscription)));
      } else if (errors.aut_dest_licenseplate) {
        dispatch(warningErrorAction(t(errors.aut_dest_licenseplate)));
      } else if (errors.aut_dest_economicactivity) {
        dispatch(warningErrorAction(t(errors.aut_dest_economicactivity)));
      } else if (errors.rel_trans_documentid) {
        dispatch(warningErrorAction(t(errors.rel_trans_documentid)));
      } else if (errors.rel_trans_tradename) {
        dispatch(warningErrorAction(t(errors.rel_trans_tradename)));
      } else if (errors.rel_trans_name) {
        dispatch(warningErrorAction(t(errors.rel_trans_name)));
      } else if (errors.rel_trans_contactname) {
        dispatch(warningErrorAction(t(errors.rel_trans_contactname)));
      } else if (errors.rel_trans_street) {
        dispatch(warningErrorAction(t(errors.rel_trans_street)));
      } else if (errors.rel_trans_postalcode_code) {
        dispatch(warningErrorAction(t(errors.rel_trans_postalcode_code)));
      } else if (errors.rel_trans_phone) {
        dispatch(warningErrorAction(t(errors.rel_trans_phone)));
      } else if (errors.rel_trans_email) {
        dispatch(warningErrorAction(t(errors.rel_trans_email)));
      } else if (errors.rel_trans_nima) {
        dispatch(warningErrorAction(t(errors.rel_trans_nima)));
      } else if (errors.rel_trans_cnae) {
        dispatch(warningErrorAction(t(errors.rel_trans_cnae)));
      } else if (errors.rel_trans_inscription) {
        dispatch(warningErrorAction(t(errors.rel_trans_inscription)));
      } else if (errors.rel_trans_licenseplate) {
        dispatch(warningErrorAction(t(errors.rel_trans_licenseplate)));
      } else if (errors.rel_trans_economicactivity) {
        dispatch(warningErrorAction(t(errors.rel_trans_economicactivity)));
      } else if (errors.resp_prod_documentid) {
        dispatch(warningErrorAction(t(errors.resp_prod_documentid)));
      } else if (errors.resp_prod_tradename) {
        dispatch(warningErrorAction(t(errors.resp_prod_tradename)));
      } else if (errors.resp_prod_name) {
        dispatch(warningErrorAction(t(errors.resp_prod_name)));
      } else if (errors.resp_prod_contactname) {
        dispatch(warningErrorAction(t(errors.resp_prod_contactname)));
      } else if (errors.resp_prod_street) {
        dispatch(warningErrorAction(t(errors.resp_prod_street)));
      } else if (errors.resp_prod_postalcode_code) {
        dispatch(warningErrorAction(t(errors.resp_prod_postalcode_code)));
      } else if (errors.resp_prod_phone) {
        dispatch(warningErrorAction(t(errors.resp_prod_phone)));
      } else if (errors.resp_prod_email) {
        dispatch(warningErrorAction(t(errors.resp_prod_email)));
      } else if (errors.resp_prod_nima) {
        dispatch(warningErrorAction(t(errors.resp_prod_nima)));
      } else if (errors.resp_prod_cnae) {
        dispatch(warningErrorAction(t(errors.resp_prod_cnae)));
      } else if (errors.resp_prod_inscription) {
        dispatch(warningErrorAction(t(errors.resp_prod_inscription)));
      } else if (errors.resp_prod_licenseplate) {
        dispatch(warningErrorAction(t(errors.resp_prod_licenseplate)));
      } else if (errors.resp_prod_economicactivity) {
        dispatch(warningErrorAction(t(errors.resp_prod_economicactivity)));
      } else if (errors.codeler_code) {
        dispatch(warningErrorAction(t(errors.codeler_code)));
      } else if (errors.charac_danger) {
        dispatch(warningErrorAction(t(errors.charac_danger)));
      } else if (errors.reason_refund) {
        dispatch(warningErrorAction(t(errors.reason_refund)));
      } else if (errors.action_refund) {
        dispatch(warningErrorAction(t(errors.action_refund)));
      } else if (errors.date_refund) {
        dispatch(warningErrorAction(t(errors.date_refund)));
      } else if (errors.observations) {
          dispatch(warningErrorAction(t(errors.observations)));
      } else {
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      }
    }
  }; 
  
  useEffect(() => {
    let isMounted = true;
    const fetchExistNumberFormDI = async () => {
        try {
          const getData = await helpHttp().get5(ENDPOINT,`form/getexistnumberdi`,token,formForm.preiddoc_sheet.replace(/[.\-/\\|]/g, ""),formForm.sufiddoc_sheet) ;
          if (getData.err) {
            dispatch(warningErrorAction(t('Text_InvalidCredentials')));
          } else if (isMounted) {
            setFoundNumberOfDI(getData!==formForm.id && getData>0)       
          }
        } catch (error) {
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }
    }; 
    if (formForm.preiddoc_sheet && formForm.preiddoc_sheet.replace(/[.\-/\\|]/g, "").trim()!==""){
      fetchExistNumberFormDI();
    }
    return () => { isMounted = false };
  }, [t,token,dispatch,formForm.preiddoc_sheet,formForm.sufiddoc_sheet,formForm.id]);
 
  useEffect(() => {
    let isMounted = true;
    const fetchGetNumberFormDI = async () => {
        try {
          const getData = await helpHttp().get8(ENDPOINT,`form/getlastnumberdi`,token,defaultStore.id,formForm.preiddoc_sheet) ;
          if (getData.err) {
            dispatch(warningErrorAction(t('Text_InvalidCredentials')));
          } else if (isMounted && getData>0) {
             setFormForm(formForm => ({
              ...formForm,
              sufiddoc_sheet: getData
            }));       
          }else{
             setFormForm(formForm => ({
              ...formForm,
              sufiddoc_sheet: Number(new Date().getFullYear())*10000000+1
            }));       
          }
        } catch (error) {
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }
    }; 
    if (formForm.preiddoc_sheet && (id===undefined  || id===null  || id==="" || id===0 || id==="0")){
      fetchGetNumberFormDI();
    } 
    return () => { isMounted = false };
  }, [t,token,dispatch,formForm.preiddoc_sheet,formForm.number_dt,defaultStore.id,id]);

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);

  useEffect(() => {
    let isMounted = true;
    const fetchExistNT = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT,`searchdcs/getexistntbynumbernt/`,token,formForm.number_dt.replace(/[.\-/\\|]/g, "").trim());
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          if (getData!==undefined && getData!==null && getData!=="" && getData>0){
            fetchNT();
          }
        }  
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    }; 
    const fetchNT = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT,`searchdcs/getntbynumbernt/`,token,formForm.number_dt.replace(/[.\-/\\|]/g, "").trim());
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          if (getData){
            let preiddoc_sheet="DCS30"+(defaulttypesdi.default_opt_tras_nima || getData.opt_tras_nima);   
            let sufiddoc_sheet=defaulttypesdi.default_sufiddoc_sheet>0?defaulttypesdi.default_sufiddoc_sheet:(getData.default_sufiddoc_sheet || Number(new Date().getFullYear())*10000000+1);
            setFormForm(formForm => ({
              ...formForm,
              number_dt:getData.number_nt || formForm.number_dt,
              preiddoc_sheet:preiddoc_sheet,
              sufiddoc_sheet:formForm.sufiddoc_sheet>0?formForm.sufiddoc_sheet:sufiddoc_sheet,
              
              opt_tras_store_id:getData.opt_tras_store_id || formForm.opt_tras_store_id,
              opt_tras_documnettype_id:getData.opt_tras_documnettype_id || formForm.opt_tras_documnettype_id,
              opt_tras_documentid:getData.opt_tras_documentid || formForm.opt_tras_documentid,
              opt_tras_tradename:getData.opt_tras_tradename || formForm.opt_tras_tradename,
              opt_tras_name:getData.opt_tras_name || formForm.opt_tras_name,
              opt_tras_contactname:getData.opt_tras_contactname || formForm.opt_tras_contactname,
              opt_tras_roadtype_id:getData.opt_tras_roadtype_id || formForm.opt_tras_roadtype_id,
              opt_tras_street:getData.opt_tras_street || formForm.opt_tras_street,
              opt_tras_country_id:getData.opt_tras_country_id || formForm.opt_tras_country_id,
              opt_tras_country_name:getData.opt_tras_country_name || formForm.opt_tras_country_name,
              opt_tras_province_id:getData.opt_tras_province_id || formForm.opt_tras_province_id,
              opt_tras_province_name:getData.opt_tras_province_name || formForm.opt_tras_province_name,
              opt_tras_postalcode_id:getData.opt_tras_postalcode_id || formForm.opt_tras_postalcode_id,
              opt_tras_postalcode_code:getData.opt_tras_postalcode_code || formForm.opt_tras_postalcode_code,
              opt_tras_postalcode_name:getData.opt_tras_postalcode_name || formForm.opt_tras_postalcode_name,
              opt_tras_community_id:getData.opt_tras_community_id || formForm.opt_tras_community_id,
              opt_tras_community_name:getData.opt_tras_community_name || formForm.opt_tras_community_name,
              opt_tras_phone:getData.opt_tras_phone || formForm.opt_tras_phone,
              opt_tras_email:getData.opt_tras_email || formForm.opt_tras_email,
              opt_tras_nima:getData.opt_tras_nima || formForm.opt_tras_nima,
              opt_tras_cnae:getData.opt_tras_cnae || formForm.opt_tras_cnae,
              opt_tras_inscription:getData.opt_tras_inscription || formForm.opt_tras_inscription,
              opt_tras_opt:getData.opt_tras_opt || formForm.opt_tras_opt,
              opt_tras_licenseplate:getData.opt_tras_licenseplate || formForm.opt_tras_licenseplate,
              opt_tras_economicactivity:getData.opt_tras_economicactivity || formForm.opt_tras_economicactivity,
              
              ori_tras_store_id:getData.ori_tras_store_id || formForm.ori_tras_store_id,
              ori_tras_documnettype_id:getData.ori_tras_documnettype_id || formForm.ori_tras_documnettype_id,
              ori_tras_documentid:getData.ori_tras_documentid || formForm.ori_tras_documentid,
              ori_tras_tradename:getData.ori_tras_tradename || formForm.ori_tras_tradename,
              ori_tras_name:getData.ori_tras_name || formForm.ori_tras_name,
              ori_tras_contactname:getData.ori_tras_contactname || formForm.ori_tras_contactname,
              ori_tras_roadtype_id:getData.ori_tras_roadtype_id || formForm.ori_tras_roadtype_id,
              ori_tras_street:getData.ori_tras_street || formForm.ori_tras_street,
              ori_tras_country_id:getData.ori_tras_country_id || formForm.ori_tras_country_id,
              ori_tras_country_name:getData.ori_tras_country_name || formForm.ori_tras_country_name,
              ori_tras_province_id:getData.ori_tras_province_id || formForm.ori_tras_province_id,
              ori_tras_province_name:getData.ori_tras_province_name || formForm.ori_tras_province_name,
              ori_tras_postalcode_id:getData.ori_tras_postalcode_id || formForm.ori_tras_postalcode_id,
              ori_tras_postalcode_code:getData.ori_tras_postalcode_code || formForm.ori_tras_postalcode_code,
              ori_tras_postalcode_name:getData.ori_tras_postalcode_name || formForm.ori_tras_postalcode_name,
              ori_tras_community_id:getData.ori_tras_community_id || formForm.ori_tras_community_id,
              ori_tras_community_name:getData.ori_tras_community_name || formForm.ori_tras_community_name,
              ori_tras_phone:getData.ori_tras_phone || formForm.ori_tras_phone,
              ori_tras_email:getData.ori_tras_email || formForm.ori_tras_email,
              ori_tras_nima:getData.ori_tras_nima || formForm.ori_tras_nima,
              ori_tras_cnae:getData.ori_tras_cnae || formForm.ori_tras_cnae,
              ori_tras_inscription:getData.ori_tras_inscription || formForm.ori_tras_inscription,
              ori_tras_opt:getData.ori_tras_opt || formForm.ori_tras_opt,
              ori_tras_licenseplate:getData.ori_tras_licenseplate || formForm.ori_tras_licenseplate,
              ori_tras_economicactivity:getData.ori_tras_economicactivity || formForm.ori_tras_economicactivity,
             
              aut_tras_store_id:getData.aut_tras_store_id || formForm.aut_tras_store_id,
              aut_tras_documnettype_id:getData.aut_tras_documnettype_id || formForm.aut_tras_documnettype_id,
              aut_tras_documentid:getData.aut_tras_documentid || formForm.aut_tras_documentid,
              aut_tras_tradename:getData.aut_tras_tradename || formForm.aut_tras_tradename,
              aut_tras_name:getData.aut_tras_name || formForm.aut_tras_name,
              aut_tras_contactname:getData.aut_tras_contactname || formForm.aut_tras_contactname,
              aut_tras_roadtype_id:getData.aut_tras_roadtype_id || formForm.aut_tras_roadtype_id,
              aut_tras_street:getData.aut_tras_street || formForm.aut_tras_street,
              aut_tras_country_id:getData.aut_tras_country_id || formForm.aut_tras_country_id,
              aut_tras_country_name:getData.aut_tras_country_name || formForm.aut_tras_country_name,
              aut_tras_province_id:getData.aut_tras_province_id || formForm.aut_tras_province_id,
              aut_tras_province_name:getData.aut_tras_province_name || formForm.aut_tras_province_name,
              aut_tras_postalcode_id:getData.aut_tras_postalcode_id || formForm.aut_tras_postalcode_id,
              aut_tras_postalcode_code:getData.aut_tras_postalcode_code || formForm.aut_tras_postalcode_code,
              aut_tras_postalcode_name:getData.aut_tras_postalcode_name || formForm.aut_tras_postalcode_name,
              aut_tras_community_id:getData.aut_tras_community_id || formForm.aut_tras_community_id,
              aut_tras_community_name:getData.aut_tras_community_name || formForm.aut_tras_community_name,
              aut_tras_phone:getData.aut_tras_phone || formForm.aut_tras_phone,
              aut_tras_email:getData.aut_tras_email || formForm.aut_tras_email,
              aut_tras_nima:getData.aut_tras_nima || formForm.aut_tras_nima,
              aut_tras_cnae:getData.aut_tras_cnae || formForm.aut_tras_cnae,
              aut_tras_inscription:getData.aut_tras_inscription || formForm.aut_tras_inscription,
              aut_tras_opt:getData.aut_tras_opt || formForm.aut_tras_opt,
              aut_tras_licenseplate:getData.aut_tras_licenseplate || formForm.aut_tras_licenseplate,
              aut_tras_economicactivity:getData.aut_tras_economicactivity || formForm.aut_tras_economicactivity,

              dest_tras_store_id:getData.dest_tras_store_id || formForm.dest_tras_store_id,
              dest_tras_documnettype_id:getData.dest_tras_documnettype_id || formForm.dest_tras_documnettype_id,
              dest_tras_documentid:getData.dest_tras_documentid || formForm.dest_tras_documentid,
              dest_tras_tradename:getData.dest_tras_tradename || formForm.dest_tras_tradename,
              dest_tras_name:getData.dest_tras_name || formForm.dest_tras_name,
              dest_tras_contactname:getData.dest_tras_contactname || formForm.dest_tras_contactname,
              dest_tras_roadtype_id:getData.dest_tras_roadtype_id || formForm.dest_tras_roadtype_id,
              dest_tras_street:getData.dest_tras_street || formForm.dest_tras_street,
              dest_tras_country_id:getData.dest_tras_country_id || formForm.dest_tras_country_id,
              dest_tras_country_name:getData.dest_tras_country_name || formForm.dest_tras_country_name,
              dest_tras_province_id:getData.dest_tras_province_id || formForm.dest_tras_province_id,
              dest_tras_province_name:getData.dest_tras_province_name || formForm.dest_tras_province_name,
              dest_tras_postalcode_id:getData.dest_tras_postalcode_id || formForm.dest_tras_postalcode_id,
              dest_tras_postalcode_code:getData.dest_tras_postalcode_code || formForm.dest_tras_postalcode_code,
              dest_tras_postalcode_name:getData.dest_tras_postalcode_name || formForm.dest_tras_postalcode_name,
              dest_tras_community_id:getData.dest_tras_community_id || formForm.dest_tras_community_id,
              dest_tras_community_name:getData.dest_tras_community_name || formForm.dest_tras_community_name,
              dest_tras_phone:getData.dest_tras_phone || formForm.dest_tras_phone,
              dest_tras_email:getData.dest_tras_email || formForm.dest_tras_email,
              dest_tras_nima:getData.dest_tras_nima || formForm.dest_tras_nima,
              dest_tras_cnae:getData.dest_tras_cnae || formForm.dest_tras_cnae,
              dest_tras_inscription:getData.dest_tras_inscription || formForm.dest_tras_inscription,
              dest_tras_opt:getData.dest_tras_opt || formForm.dest_tras_opt,
              dest_tras_licenseplate:getData.dest_tras_licenseplate || formForm.dest_tras_licenseplate,
              dest_tras_economicactivity:getData.dest_tras_economicactivity || formForm.dest_tras_economicactivity,

              aut_dest_store_id:getData.aut_dest_store_id || formForm.aut_dest_store_id,
              aut_dest_documnettype_id:getData.aut_dest_documnettype_id || formForm.aut_dest_documnettype_id,
              aut_dest_documentid:getData.aut_dest_documentid || formForm.aut_dest_documentid,
              aut_dest_tradename:getData.aut_dest_tradename || formForm.aut_dest_tradename,
              aut_dest_name:getData.aut_dest_name || formForm.aut_dest_name,
              aut_dest_contactname:getData.aut_dest_contactname || formForm.aut_dest_contactname,
              aut_dest_roadtype_id:getData.aut_dest_roadtype_id || formForm.aut_dest_roadtype_id,
              aut_dest_street:getData.aut_dest_street || formForm.aut_dest_street,
              aut_dest_country_id:getData.aut_dest_country_id || formForm.aut_dest_country_id,
              aut_dest_country_name:getData.aut_dest_country_name || formForm.aut_dest_country_name,
              aut_dest_province_id:getData.aut_dest_province_id || formForm.aut_dest_province_id,
              aut_dest_province_name:getData.aut_dest_province_name || formForm.aut_dest_province_name,
              aut_dest_postalcode_id:getData.aut_dest_postalcode_id || formForm.aut_dest_postalcode_id,
              aut_dest_postalcode_code:getData.aut_dest_postalcode_code || formForm.aut_dest_postalcode_code,
              aut_dest_postalcode_name:getData.aut_dest_postalcode_name || formForm.aut_dest_postalcode_name,
              aut_dest_community_id:getData.aut_dest_community_id || formForm.aut_dest_community_id,
              aut_dest_community_name:getData.aut_dest_community_name || formForm.aut_dest_community_name,
              aut_dest_phone:getData.aut_dest_phone || formForm.aut_dest_phone,
              aut_dest_email:getData.aut_dest_email || formForm.aut_dest_email,
              aut_dest_nima:getData.aut_dest_nima || formForm.aut_dest_nima,
              aut_dest_cnae:getData.aut_dest_cnae || formForm.aut_dest_cnae,
              aut_dest_inscription:getData.aut_dest_inscription || formForm.aut_dest_inscription,
              aut_dest_opt:getData.aut_dest_opt || formForm.aut_dest_opt,
              aut_dest_licenseplate:getData.aut_dest_licenseplate || formForm.aut_dest_licenseplate,
              aut_dest_economicactivity:getData.aut_dest_economicactivity || formForm.aut_dest_economicactivity,

              codeler_id:getData.codeler_id || formForm.codeler_id,
              codeler_code:getData.codeler_code || formForm.codeler_code,
              codeler_namees:getData.codeler_namees || formForm.codeler_namees,
              codeler_nameen:getData.codeler_nameen || formForm.codeler_nameen,
              description_id:getData.description_id || formForm.description_id,
              description_code:getData.description_code || formForm.description_code,
              description_namees:getData.description_namees || formForm.description_namees,
              description_nameen:getData.description_nameen || formForm.description_nameen,

              treatmenttypeorigin_id:getData.treatmenttypeorigin_id || formForm.treatmenttypeorigin_id,
              treatmenttypeorigin_code:getData.treatmenttypeorigin_code || formForm.treatmenttypeorigin_code,
              treatmenttypeorigin_namees:getData.treatmenttypeorigin_namees || formForm.treatmenttypeorigin_namees,
              treatmenttypeorigin_nameen:getData.treatmenttypeorigin_nameen || formForm.treatmenttypeorigin_nameen,
              treatmenttypedestine_id:getData.treatmenttypedestine_id || formForm.treatmenttypedestine_id,
              treatmenttypedestine_code:getData.treatmenttypedestine_code || formForm.treatmenttypedestine_code,
              treatmenttypedestine_namees:getData.treatmenttypedestine_namees || formForm.treatmenttypedestine_namees,
              treatmenttypedestine_nameen:getData.treatmenttypedestine_nameen || formForm.treatmenttypedestine_nameen,
              processtypepeorigin_id:getData.processtypeorigin_id || formForm.processtypepeorigin_id,
              processtypepeorigin_code:getData.processtypeorigin_code || formForm.processtypepeorigin_code,
              processtypepeorigin_namees:getData.processtypeorigin_namees || formForm.processtypepeorigin_namees,
              processtypepeorigin_nameen:getData.processtypeorigin_nameen || formForm.processtypepeorigin_nameen,
              processtypedestine_id:getData.processtypedestine_id || formForm.processtypedestine_id,
              processtypedestine_code:getData.processtypedestine_code || formForm.processtypedestine_code,
              processtypedestine_namees:getData.processtypedestine_namees || formForm.processtypedestine_namees,
              processtypedestine_nameen:getData.processtypedestine_nameen || formForm.processtypedestine_nameen,
              dangerousness_id:getData.dangerousness_id || formForm.dangerousness_id,
              dangerousness_namees:getData.dangerousness_namees || formForm.dangerousness_namees,
              dangerousness_nameen:getData.dangerousness_nameen || formForm.dangerousness_nameen,
              amount:formForm.amount, 
   
              rel_trans_store_id: formForm.rel_trans_store_id,
              rel_trans_documnettype_id: formForm.rel_trans_documnettype_id,
              rel_trans_documentid: formForm.rel_trans_documentid,
              rel_trans_tradename: formForm.rel_trans_tradename,
              rel_trans_name: formForm.rel_trans_name,
              rel_trans_contactname: formForm.rel_trans_contactname,
              rel_trans_roadtype_id: formForm.rel_trans_roadtype_id,
              rel_trans_street: formForm.rel_trans_street,
              rel_trans_country_id: formForm.rel_trans_country_id,
              rel_trans_country_name: formForm.rel_trans_country_name,
              rel_trans_province_id: formForm.rel_trans_province_id,
              rel_trans_province_name: formForm.rel_trans_province_name,
              rel_trans_postalcode_id: formForm.rel_trans_postalcode_id,
              rel_trans_postalcode_code: formForm.rel_trans_postalcode_code,
              rel_trans_postalcode_name: formForm.rel_trans_postalcode_name,
              rel_trans_community_id: formForm.rel_trans_community_id,
              rel_trans_community_name: formForm.rel_trans_community_name,
              rel_trans_phone: formForm.rel_trans_phone,
              rel_trans_email: formForm.rel_trans_email,
              rel_trans_nima: formForm.rel_trans_nima,
              rel_trans_cnae: formForm.rel_trans_cnae,
              rel_trans_inscription: formForm.rel_trans_inscription,
              rel_trans_opt: formForm.rel_trans_opt,
              rel_trans_licenseplate: formForm.rel_trans_licenseplate,
              rel_trans_economicactivity: formForm.rel_trans_economicactivity,
  
              resp_prod_store_id: formForm.resp_prod_store_id,
              resp_prod_documnettype_id: formForm.resp_prod_documnettype_id,
              resp_prod_documentid: formForm.resp_prod_documentid,
              resp_prod_tradename: formForm.resp_prod_tradename,
              resp_prod_name: formForm.resp_prod_name,
              resp_prod_contactname: formForm.resp_prod_contactname,
              resp_prod_roadtype_id: formForm.resp_prod_roadtype_id,
              resp_prod_street: formForm.resp_prod_street,
              resp_prod_country_id: formForm.resp_prod_country_id,
              resp_prod_country_name: formForm.resp_prod_country_name,
              resp_prod_province_id: formForm.resp_prod_province_id,
              resp_prod_province_name: formForm.resp_prod_province_name,
              resp_prod_postalcode_id: formForm.resp_prod_postalcode_id,
              resp_prod_postalcode_code: formForm.resp_prod_postalcode_code,
              resp_prod_postalcode_name: formForm.resp_prod_postalcode_name,
              resp_prod_community_id: formForm.resp_prod_community_id,
              resp_prod_community_name: formForm.resp_prod_community_name,
              resp_prod_phone: formForm.resp_prod_phone,
              resp_prod_email: formForm.resp_prod_email,
              resp_prod_nima: formForm.resp_prod_nima,
              resp_prod_cnae: formForm.resp_prod_cnae,
              resp_prod_inscription: formForm.resp_prod_inscription,
              resp_prod_opt: formForm.resp_prod_opt,
              resp_prod_licenseplate: formForm.resp_prod_licenseplate,
              resp_prod_economicactivity: formForm.resp_prod_economicactivity 
            })); 
          }
        }  
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
    if (formForm.number_dt && formForm.number_dt.replace(/[.\-/\\|]/g, "").trim()!=="") { 
      fetchExistNT();
    } 
    return () => { isMounted = false };
  }, [t,token,dispatch,formForm.number_dt,setIsLoadingErrorData,setFormForm, defaulttypesdi.default_opt_tras_nima,defaulttypesdi.default_sufiddoc_sheet,
    DEFAULTCOMMUNITY,DEFAULTCOMMUNITY_NAME,DEFAULTCOUNTRY,DEFAULTCOUNTRY_NAME,DEFAULTPOSTALCODE_CODE,
    DEFAULTPOSTALCODE_ID,DEFAULTPOSTALCODE_NAME,DEFAULTPROVINCE,DEFAULTPROVINCE_NAME,DEFAULTROADTYE,DEFAULTTYPEOFDOCUMENT
  ]);

  useEffect(() => {
    let isMounted = true;

    const fetchDataRoadType = async () => {
      try {
        const getData = i18n.language === "es"
          ? await helpHttp().get(ENDPOINT, `roadtype/roadtypesorderbynamees`, token)
          : await helpHttp().get(ENDPOINT, `roadtype/roadtypesorderbynameen`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setRoadTypesToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };

    const fetchDataOptType = async () => {
      try {
        const getData = i18n.language === "es"
          ? await helpHttp().get(ENDPOINT, `opttype/opttypesorderbynamees`, token)
          : await helpHttp().get(ENDPOINT, `opttype/opttypesorderbynameen`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setOptTypeToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };

    const fetchDataCommunity = async () => {
      try {
        const getData = i18n.language === "es"
        ? await helpHttp().get(ENDPOINT, `community/simplecommunitiesbynamees`, token)
        : await helpHttp().get(ENDPOINT, `community/simplecommunitiesbynameen`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setCommunityToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };

    const fetchDataDocumentType = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT, `documenttype/simpledocumenttypesbyname`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setDocumentTypesToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };

    const fetchDataTreatmentType = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT, `treatmenttype/treatmenttypesorderbycode`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setTreatmenttypeToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };

    const fetchDataProcessType = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT, `processtype/processtypesorderbycode`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setProcesstypeToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };

    const fetchDataDangerousness = async () => {
      try {
        const getData = i18n.language==='es' 
          ?await helpHttp().get(ENDPOINT, `dangerousness/dangerousnessorderbynamees`, token)
          :await helpHttp().get(ENDPOINT, `dangerousness/dangerousnessorderbynameen`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setDangerousness(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    }; 
    if (formForm.id!==null){
      fetchDataDocumentType();
      fetchDataRoadType();
      fetchDataCommunity();
      fetchDataOptType(); 
      fetchDataTreatmentType();
      fetchDataProcessType();
      fetchDataDangerousness();
    }
    return () => { isMounted = false };
  }, [t,token,dispatch,i18n,roles,formForm.id,showModalFormSettings]);

  useEffect(() => {
    let isMounted = true;
    const fetchExistCodeLer = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT,`form/getexistcodelerbycode/`,token,formForm.codeler_code.replace(/[.\-/\\|]/g, "").trim());
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
          
        } else if (isMounted) {
          if (getData!==undefined && getData!==null && getData!=="" && getData>0){
            fetchCodeLerCode();
          }else{
            setFormForm(formForm => ({
              ...formForm,
              codeler_id: 0,
              codeler_namees: "",
              codeler_nameen: "" 
            }));
            
          }
        }  
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
    const fetchCodeLerCode = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT,`form/getformcodelerfindbycode/`,token,formForm.codeler_code.replace(/[.\-/\\|]/g, "").trim());
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
           
        } else if (isMounted) {
          if (getData!==undefined && getData!==null && getData!==""){
            setFormForm(formForm => ({
                ...formForm,
                codeler_id: getData.id, 
                codeler_namees: getData.namees,
                codeler_nameen: getData.nameen    
              }));
        }  
        }  
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
    if (formForm.codeler_code && formForm.codeler_code.replace(/[.\-/\\|]/g, "").trim()!=="") { 
      fetchExistCodeLer();
    } 
    return () => { isMounted = false };
}, [t,token,dispatch,formForm.codeler_code,setIsLoadingErrorData,setFormForm]);

useEffect(() => {
  let isMounted = true;
  const fetchExistDescription = async () => {
    try {
      const getData = await helpHttp().get2(ENDPOINT,`form/getexistdescriptionbycode/`,token,formForm.description_code.replace(/[.\-/\\|]/g, "").trim());
      if (getData.err) {
        dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        
      } else if (isMounted) {
        if (getData!==undefined && getData!==null && getData!=="" && getData>0){
          fetchDescriptionCode();
        }else{
          setFormForm(formForm => ({
            ...formForm,
            description_id: 0,
            description_namees: "",
            description_nameen: "" 
          }));
          
        }
      }  
    } catch (error) {
      dispatch(warningErrorAction(t('Text_IncorrectData'))); 
    }
  };
  const fetchDescriptionCode = async () => {
    try {
      const getData = await helpHttp().get2(ENDPOINT,`form/getformdescriptionfindbycode/`,token,formForm.description_code.replace(/[.\-/\\|]/g, "").trim());
      if (getData.err) {
        dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        
      } else if (isMounted) {
        if (getData!==undefined && getData!==null && getData!==""){
          setFormForm(formForm => ({
            ...formForm,
            description_id: getData.id, 
            description_namees: getData.namees,
            description_nameen: getData.nameen
          }));
      }  
      }  
    } catch (error) {
      dispatch(warningErrorAction(t('Text_IncorrectData'))); 
    }
  };
  if (formForm.description_code && formForm.description_code.replace(/[.\-/\\|]/g, "").trim()!=="") { 
    fetchExistDescription();
  }  
  return () => { isMounted = false };
  }, [t,token,dispatch,formForm.description_code,setIsLoadingErrorData,setFormForm]);

 const isValidPngDataURL = (value) => {
    if (typeof value !== "string") return false;
    const trimmed = value.trim();
    if (trimmed==="") return false;
    if (trimmed.includes("static/media")) return true; 
    if (!trimmed.startsWith("data:image/png;base64,")) return false;
    // longitud mínima razonable para un PNG (ajusta si quieres)
    return trimmed.length > 200; 
  };
  
  useEffect(() => {
    let isMounted = true;
    const fetchDataForm = async () => { 
      try {
        const getData = await  helpHttp().get2(ENDPOINT,`form/getformdibyId/`,token,id);
        if (getData.err) {
          setFormForm(initialStateForm); 
          dispatch(setLoading(false));
          setIsLoadingErrorData(true);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setFormForm(getData);
          dispatch(setLoading(false));
          if (getData.signature_opt_tras && isValidPngDataURL(getData.signature_opt_tras)) {
            setTimeout(() => {
              if (signDispatchedOptTrasCanvas.current) {
                drawSignatureCentered(signDispatchedOptTrasCanvas, getData.signature_opt_tras);
              }
            }, 200);
          }  
          if (getData.signature_dest_tras && isValidPngDataURL(getData.signature_dest_tras)) {
            setTimeout(() => {
              if (signDispatchedDestTrasCanvas.current) {
                drawSignatureCentered(signDispatchedDestTrasCanvas, getData.signature_dest_tras);
              }
            }, 200);
          }   
          if (getData.signature_refund && isValidPngDataURL(getData.signature_refund)) {
            setTimeout(() => {
              if (signDispatchedRefundCanvas.current) {
                drawSignatureCentered(signDispatchedRefundCanvas, getData.signature_refund);
              }
            }, 200);
          }   
          setHasbeenshared(getData.opt_tras_shared 
            || getData.ori_tras_shared
            || getData.aut_tras_shared
            || getData.dest_tras_shared
            || getData.aut_dest_shared
            || getData.rel_trans_shared)
          
          let isShared=(getData.opt_tras_shared 
            || getData.ori_tras_shared
            || getData.aut_tras_shared
            || getData.dest_tras_shared
            || getData.aut_dest_shared
            || getData.rel_trans_shared); 
          setSharedLicensePlate(isShared && getData.rel_trans_licenseplate!=="")
          setSharedAmount(isShared && getData.amount!==0);
          setShareddeliver_date(isShared && getData.deliver_date!==null && getData.deliver_date!=="") ;
          setShareddate_accepted(isShared && getData.date_accepted!==null && getData.date_accepted!=="");
          setSharedreason_refund(isShared && getData.reason_refund!==null && getData.reason_refund!=="");
          setSharedaction_refund(isShared && getData.action_refund!==null && getData.action_refund!=="");
          setShareddate_refund(isShared && getData.date_refund!==null && getData.date_refund!=="");
          setSharedobservations(isShared && getData.observations!==null && getData.observations!=="");
          setSharedsignOptTras(isShared && getData.signature_opt_tras!==null && getData.signature_opt_tras!=="");
          setSharedsignDestTras(isShared && getData.signature_dest_tras!==null && getData.signature_dest_tras!=="");
          setSharedsignRefund(isShared && getData.signature_refund!==null && getData.signature_refund!=="");
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };

    if (id!=="0"){
      if (formForm.id===""){
        dispatch(setLoading(true));
        fetchDataForm();
      }

    }else{
      setFormForm(initialStateForm);
      setFormForm(formForm => ({
        ...formForm,
        ownformdi_id:0,
        defaultStore_id:defaultStore.id,
        useraccount_id:useraccount_id,
        defaultformatnumber:defaulttypesdi.id,
        isFinished:false,
        isScanned:false,
        preiddoc_sheet:"DCS30"+defaulttypesdi.default_opt_tras_nima,
        sufiddoc_sheet:defaulttypesdi.default_sufiddoc_sheet!==undefined && defaulttypesdi.default_sufiddoc_sheet!=="" && defaulttypesdi.default_sufiddoc_sheet!=="0" && defaulttypesdi.default_sufiddoc_sheet!==0?defaulttypesdi.default_sufiddoc_sheet:Number(new Date().getFullYear())*10000000+1,
        number_dt:defaulttypesdi.default_number_dt || "",
        date_sheet:new Date(),

         formopttrasstore_id:0,
        opt_tras_store_id:defaulttypesdi.default_opt_tras_id || 0,
        opt_tras_documnettype_id:defaulttypesdi.default_opt_tras_documnettype_id!==0?defaulttypesdi.default_opt_tras_documnettype_id:Number(DEFAULTTYPEOFDOCUMENT),
        opt_tras_documentid:defaulttypesdi.default_opt_tras_documentid || "",
        opt_tras_tradename:defaulttypesdi.default_opt_tras_tradename || "",
        opt_tras_name:defaulttypesdi.default_opt_tras_name || "",
        opt_tras_contactname:defaulttypesdi.default_opt_tras_contactname || "",
        opt_tras_roadtype_id:defaulttypesdi.default_opt_tras_roadtype_id!==0?defaulttypesdi.default_opt_tras_roadtype_id: Number(DEFAULTROADTYE),
        opt_tras_street:defaulttypesdi.default_opt_tras_street || "",
        opt_tras_country_id:defaulttypesdi.default_opt_tras_country_id!==0?defaulttypesdi.default_opt_tras_country_id:Number(DEFAULTCOUNTRY),
        opt_tras_country_name:defaulttypesdi.default_opt_tras_country_name!==""?defaulttypesdi.default_opt_tras_country_name:DEFAULTCOUNTRY_NAME,
        opt_tras_province_id:defaulttypesdi.default_opt_tras_province_id!==0?defaulttypesdi.default_opt_tras_province_id:Number(DEFAULTPROVINCE),
        opt_tras_province_name:defaulttypesdi.default_opt_tras_province_name!==""?defaulttypesdi.default_opt_tras_province_name:DEFAULTPROVINCE_NAME,
        opt_tras_postalcode_id:defaulttypesdi.default_opt_tras_postalcode_id!==0?defaulttypesdi.default_opt_tras_postalcode_id:Number(DEFAULTPOSTALCODE_ID),
        opt_tras_postalcode_code:defaulttypesdi.default_opt_tras_postalcode_code!==""?defaulttypesdi.default_opt_tras_postalcode_code:DEFAULTPOSTALCODE_CODE,
        opt_tras_postalcode_name:defaulttypesdi.default_opt_tras_postalcode_name!==""?defaulttypesdi.default_opt_tras_postalcode_name:DEFAULTPOSTALCODE_NAME,
        opt_tras_community_id:defaulttypesdi.default_opt_tras_community_id!==0?defaulttypesdi.default_opt_tras_community_id:Number(DEFAULTCOMMUNITY),
        opt_tras_community_name:defaulttypesdi.default_opt_tras_community_name!==""?defaulttypesdi.default_opt_tras_community_name:DEFAULTCOMMUNITY_NAME,
        opt_tras_phone:defaulttypesdi.default_opt_tras_phone || "",
        opt_tras_email:defaulttypesdi.default_opt_tras_email || "",
        opt_tras_nima:defaulttypesdi.default_opt_tras_nima || "",
        opt_tras_cnae:defaulttypesdi.default_opt_tras_cnae || "",
        opt_tras_inscription:defaulttypesdi.default_opt_tras_inscription || "",
        opt_tras_opt:defaulttypesdi.default_opt_tras_opt || 0,
        opt_tras_licenseplate:defaulttypesdi.default_opt_tras_licenseplate || "",
        opt_tras_economicactivity:defaulttypesdi.default_opt_tras_economicactivit || "",
        
        formoritrasstore_id:0,
        ori_tras_store_id:defaulttypesdi.default_ori_tras_id || 0,
        ori_tras_documnettype_id:defaulttypesdi.default_ori_tras_documnettype_id!==0?defaulttypesdi.default_ori_tras_documnettype_id:Number(DEFAULTTYPEOFDOCUMENT),
        ori_tras_documentid:defaulttypesdi.default_ori_tras_documentid || "",
        ori_tras_tradename:defaulttypesdi.default_ori_tras_tradename || "",
        ori_tras_name:defaulttypesdi.default_ori_tras_name || "",
        ori_tras_contactname:defaulttypesdi.default_ori_tras_contactname || "",
        ori_tras_roadtype_id:defaulttypesdi.default_ori_tras_roadtype_id!==0?defaulttypesdi.default_ori_tras_roadtype_id: Number(DEFAULTROADTYE),
        ori_tras_street:defaulttypesdi.default_ori_tras_street || "",
        ori_tras_country_id:defaulttypesdi.default_ori_tras_country_id!==0?defaulttypesdi.default_ori_tras_country_id:Number(DEFAULTCOUNTRY),
        ori_tras_country_name:defaulttypesdi.default_ori_tras_country_name!==""?defaulttypesdi.default_ori_tras_country_name:DEFAULTCOUNTRY_NAME,
        ori_tras_province_id:defaulttypesdi.default_ori_tras_province_id!==0?defaulttypesdi.default_ori_tras_province_id:Number(DEFAULTPROVINCE),
        ori_tras_province_name:defaulttypesdi.default_ori_tras_province_name!==""?defaulttypesdi.default_ori_tras_province_name:DEFAULTPROVINCE_NAME,
        ori_tras_postalcode_id:defaulttypesdi.default_ori_tras_postalcode_id!==0?defaulttypesdi.default_ori_tras_postalcode_id:Number(DEFAULTPOSTALCODE_ID),
        ori_tras_postalcode_code:defaulttypesdi.default_ori_tras_postalcode_code!==""?defaulttypesdi.default_ori_tras_postalcode_code:DEFAULTPOSTALCODE_CODE,
        ori_tras_postalcode_name:defaulttypesdi.default_ori_tras_postalcode_name!==""?defaulttypesdi.default_ori_tras_postalcode_name:DEFAULTPOSTALCODE_NAME,
        ori_tras_community_id:defaulttypesdi.default_ori_tras_community_id!==0?defaulttypesdi.default_ori_tras_community_id:Number(DEFAULTCOMMUNITY),
        ori_tras_community_name:defaulttypesdi.default_ori_tras_community_name!==""?defaulttypesdi.default_ori_tras_community_name:DEFAULTCOMMUNITY_NAME,
        ori_tras_phone:defaulttypesdi.default_ori_tras_phone || "",
        ori_tras_email:defaulttypesdi.default_ori_tras_email || "",
        ori_tras_nima:defaulttypesdi.default_ori_tras_nima || "",
        ori_tras_cnae:defaulttypesdi.default_ori_tras_cnae || "",
        ori_tras_inscription:defaulttypesdi.default_ori_tras_inscription || "",
        ori_tras_opt:defaulttypesdi.default_ori_tras_opt || 0,
        ori_tras_licenseplate:defaulttypesdi.default_ori_tras_licenseplate || "",
        ori_tras_economicactivity:defaulttypesdi.default_ori_tras_economicactivity || "",

        aut_tras_store_id:defaulttypesdi.default_aut_tras_id || 0,
        aut_tras_documnettype_id:defaulttypesdi.default_aut_tras_documnettype_id!==0?defaulttypesdi.default_aut_tras_documnettype_id:Number(DEFAULTTYPEOFDOCUMENT),
        aut_tras_documentid:defaulttypesdi.default_aut_tras_documentid || "",
        aut_tras_tradename:defaulttypesdi.default_aut_tras_tradename || "",
        aut_tras_name:defaulttypesdi.default_aut_tras_name || "",
        aut_tras_contactname:defaulttypesdi.default_aut_tras_contactname || "",
        aut_tras_roadtype_id:defaulttypesdi.default_aut_tras_roadtype_id!==0?defaulttypesdi.default_aut_tras_roadtype_id: Number(DEFAULTROADTYE),
        aut_tras_street:defaulttypesdi.default_aut_tras_street || "",
        aut_tras_country_id:defaulttypesdi.default_aut_tras_country_id!==0?defaulttypesdi.default_aut_tras_country_id:Number(DEFAULTCOUNTRY),
        aut_tras_country_name:defaulttypesdi.default_aut_tras_country_name!==""?defaulttypesdi.default_aut_tras_country_name:DEFAULTCOUNTRY_NAME,
        aut_tras_province_id:defaulttypesdi.default_aut_tras_province_id!==0?defaulttypesdi.default_aut_tras_province_id:Number(DEFAULTPROVINCE),
        aut_tras_province_name:defaulttypesdi.default_aut_tras_province_name!==""?defaulttypesdi.default_aut_tras_province_name:DEFAULTPROVINCE_NAME,
        aut_tras_postalcode_id:defaulttypesdi.default_aut_tras_postalcode_id!==0?defaulttypesdi.default_aut_tras_postalcode_id:Number(DEFAULTPOSTALCODE_ID),
        aut_tras_postalcode_code:defaulttypesdi.default_aut_tras_postalcode_code!==""?defaulttypesdi.default_aut_tras_postalcode_code:DEFAULTPOSTALCODE_CODE,
        aut_tras_postalcode_name:defaulttypesdi.default_aut_tras_postalcode_name!==""?defaulttypesdi.default_aut_tras_postalcode_name:DEFAULTPOSTALCODE_NAME,
        aut_tras_community_id:defaulttypesdi.default_aut_tras_community_id!==0?defaulttypesdi.default_aut_tras_community_id:Number(DEFAULTCOMMUNITY),
        aut_tras_community_name:defaulttypesdi.default_aut_tras_community_name!==""?defaulttypesdi.default_aut_tras_community_name:DEFAULTCOMMUNITY_NAME,
        aut_tras_phone:defaulttypesdi.default_aut_tras_phone || "",
        aut_tras_email:defaulttypesdi.default_aut_tras_email || "",
        aut_tras_nima:defaulttypesdi.default_aut_tras_nima || "",
        aut_tras_cnae:defaulttypesdi.default_aut_tras_cnae || "",
        aut_tras_inscription:defaulttypesdi.default_aut_tras_inscription || "",
        aut_tras_opt:defaulttypesdi.default_aut_tras_opt || 0,
        aut_tras_licenseplate:defaulttypesdi.default_aut_tras_licenseplate || "",
        aut_tras_economicactivity:defaulttypesdi.default_aut_tras_economicactivity || "",

        formdesttrasstore_id:0,
        dest_tras_store_id:defaulttypesdi.default_dest_tras_id || 0,
        dest_tras_documnettype_id:defaulttypesdi.default_dest_tras_documnettype_id!==0?defaulttypesdi.default_dest_tras_documnettype_id:Number(DEFAULTTYPEOFDOCUMENT),
        dest_tras_documentid:defaulttypesdi.default_dest_tras_documentid || "",
        dest_tras_tradename:defaulttypesdi.default_dest_tras_tradename || "",
        dest_tras_name:defaulttypesdi.default_dest_tras_name || "",
        dest_tras_contactname:defaulttypesdi.default_dest_tras_contactname || "",
        dest_tras_roadtype_id:defaulttypesdi.default_dest_tras_roadtype_id!==0?defaulttypesdi.default_dest_tras_roadtype_id: Number(DEFAULTROADTYE),
        dest_tras_street:defaulttypesdi.default_dest_tras_street || "",
        dest_tras_country_id:defaulttypesdi.default_dest_tras_country_id!==0?defaulttypesdi.default_dest_tras_country_id:Number(DEFAULTCOUNTRY),
        dest_tras_country_name:defaulttypesdi.default_dest_tras_country_name!==""?defaulttypesdi.default_dest_tras_country_name:DEFAULTCOUNTRY_NAME,
        dest_tras_province_id:defaulttypesdi.default_dest_tras_province_id!==0?defaulttypesdi.default_dest_tras_province_id:Number(DEFAULTPROVINCE),
        dest_tras_province_name:defaulttypesdi.default_dest_tras_province_name!==""?defaulttypesdi.default_dest_tras_province_name:DEFAULTPROVINCE_NAME,
        dest_tras_postalcode_id:defaulttypesdi.default_dest_tras_postalcode_id!==0?defaulttypesdi.default_dest_tras_postalcode_id:Number(DEFAULTPOSTALCODE_ID),
        dest_tras_postalcode_code:defaulttypesdi.default_dest_tras_postalcode_code!==""?defaulttypesdi.default_dest_tras_postalcode_code:DEFAULTPOSTALCODE_CODE,
        dest_tras_postalcode_name:defaulttypesdi.default_dest_tras_postalcode_name!==""?defaulttypesdi.default_dest_tras_postalcode_name:DEFAULTPOSTALCODE_NAME,
        dest_tras_community_id:defaulttypesdi.default_dest_tras_community_id!==0?defaulttypesdi.default_dest_tras_community_id:Number(DEFAULTCOMMUNITY),
        dest_tras_community_name:defaulttypesdi.default_dest_tras_community_name!==""?defaulttypesdi.default_dest_tras_community_name:DEFAULTCOMMUNITY_NAME,
        dest_tras_phone:defaulttypesdi.default_dest_tras_phone || "",
        dest_tras_email:defaulttypesdi.default_dest_tras_email || "",
        dest_tras_nima:defaulttypesdi.default_dest_tras_nima || "",
        dest_tras_cnae:defaulttypesdi.default_dest_tras_cnae || "",
        dest_tras_inscription:defaulttypesdi.default_dest_tras_inscription || "",
        dest_tras_opt:defaulttypesdi.default_dest_tras_opt || 0,
        dest_tras_licenseplate:defaulttypesdi.default_dest_tras_licenseplate || "",
        dest_tras_economicactivity:defaulttypesdi.default_dest_tras_economicactivity || "",

        aut_dest_store_id:defaulttypesdi.default_aut_dest_id || 0,
        aut_dest_documnettype_id:defaulttypesdi.default_aut_dest_documnettype_id!==0?defaulttypesdi.default_aut_dest_documnettype_id:Number(DEFAULTTYPEOFDOCUMENT),
        aut_dest_documentid:defaulttypesdi.default_aut_dest_documentid || "",
        aut_dest_tradename:defaulttypesdi.default_aut_dest_tradename || "",
        aut_dest_name:defaulttypesdi.default_aut_dest_name || "",
        aut_dest_contactname:defaulttypesdi.default_aut_dest_contactname || "",
        aut_dest_roadtype_id:defaulttypesdi.default_aut_dest_roadtype_id!==0?defaulttypesdi.default_aut_dest_roadtype_id: Number(DEFAULTROADTYE),
        aut_dest_street:defaulttypesdi.default_aut_dest_street || "",
        aut_dest_country_id:defaulttypesdi.default_aut_dest_country_id!==0?defaulttypesdi.default_aut_dest_country_id:Number(DEFAULTCOUNTRY),
        aut_dest_country_name:defaulttypesdi.default_aut_dest_country_name!==""?defaulttypesdi.default_aut_dest_country_name:DEFAULTCOUNTRY_NAME,
        aut_dest_province_id:defaulttypesdi.default_aut_dest_province_id!==0?defaulttypesdi.default_aut_dest_province_id:Number(DEFAULTPROVINCE),
        aut_dest_province_name:defaulttypesdi.default_aut_dest_province_name!==""?defaulttypesdi.default_aut_dest_province_name:DEFAULTPROVINCE_NAME,
        aut_dest_postalcode_id:defaulttypesdi.default_aut_dest_postalcode_id!==0?defaulttypesdi.default_aut_dest_postalcode_id:Number(DEFAULTPOSTALCODE_ID),
        aut_dest_postalcode_code:defaulttypesdi.default_aut_dest_postalcode_code!==""?defaulttypesdi.default_aut_dest_postalcode_code:DEFAULTPOSTALCODE_CODE,
        aut_dest_postalcode_name:defaulttypesdi.default_aut_dest_postalcode_name!==""?defaulttypesdi.default_aut_dest_postalcode_name:DEFAULTPOSTALCODE_NAME,
        aut_dest_community_id:defaulttypesdi.default_aut_dest_community_id!==0?defaulttypesdi.default_aut_dest_community_id:Number(DEFAULTCOMMUNITY),
        aut_dest_community_name:defaulttypesdi.default_aut_dest_community_name!==""?defaulttypesdi.default_aut_dest_community_name:DEFAULTCOMMUNITY_NAME,
        aut_dest_phone:defaulttypesdi.default_aut_dest_phone || "",
        aut_dest_email:defaulttypesdi.default_aut_dest_email || "",
        aut_dest_nima:defaulttypesdi.default_aut_dest_nima || "",
        aut_dest_cnae:defaulttypesdi.default_aut_dest_cnae || "",
        aut_dest_inscription:defaulttypesdi.default_aut_dest_inscription || "",
        aut_dest_opt:defaulttypesdi.default_aut_dest_opt || 0,
        aut_dest_licenseplate:defaulttypesdi.default_aut_dest_licenseplate || "",
        aut_dest_economicactivity:defaulttypesdi.default_aut_dest_economicactivity || "",

        codeler_id:defaulttypesdi.default_codeler_id || 0,
        codeler_code:defaulttypesdi.default_codeler_code || "",
        codeler_namees:defaulttypesdi.default_codeler_namees || "",
        codeler_nameen:defaulttypesdi.default_codeler_nameen || "",
        description_id:defaulttypesdi.default_description_id || 0,
        description_code:defaulttypesdi.default_description_code || "",
        description_namees:defaulttypesdi.default_description_namees || "",
        description_nameen:defaulttypesdi.default_description_nameen || "",

        treatmenttypeorigin_id:defaulttypesdi.default_treatmenttypeorigin_id || 0,
        treatmenttypeorigin_code:defaulttypesdi.default_treatmenttypeorigin_code || "",
        treatmenttypeorigin_namees:defaulttypesdi.default_treatmenttypeorigin_namees || "",
        treatmenttypeorigin_nameen:defaulttypesdi.default_treatmenttypeorigin_nameen || "",

        treatmenttypedestine_id:defaulttypesdi.default_treatmenttypedestine_id || 0,
        treatmenttypedestine_code:defaulttypesdi.default_treatmenttypedestine_code || "",
        treatmenttypedestine_namees:defaulttypesdi.default_treatmenttypedestine_namees || "",
        treatmenttypedestine_nameen:defaulttypesdi.default_treatmenttypedestine_nameen || "",

        processtypepeorigin_id:defaulttypesdi.default_processtypeorigin_id || 0,
        processtypepeorigin_code:defaulttypesdi.default_processtypeorigin_code || "",
        processtypepeorigin_namees:defaulttypesdi.default_processtypeorigin_namees || "",
        processtypepeorigin_nameen:defaulttypesdi.default_processtypeorigin_nameen || "",

        processtypedestine_id:defaulttypesdi.default_processtypedestine_id || 0,
        processtypedestine_code:defaulttypesdi.default_processtypedestine_code || "",
        processtypedestine_namees:defaulttypesdi.default_processtypedestine_namees || "",
        processtypedestine_nameen:defaulttypesdi.default_processtypedestine_nameen || "",

        dangerousness_id:defaulttypesdi.default_dangerousness_id || 0,
        dangerousness_namees:defaulttypesdi.default_dangerousness_namees || "",
        dangerousness_nameen:defaulttypesdi.default_dangerousness_nameen || "",

        formreltransstore_id:0,
        rel_trans_store_id:defaulttypesdi.default_rel_trans_id || 0,
        rel_trans_documnettype_id:defaulttypesdi.default_rel_trans_documnettype_id!==0?defaulttypesdi.default_rel_trans_documnettype_id:Number(DEFAULTTYPEOFDOCUMENT),
        rel_trans_documentid:defaulttypesdi.default_rel_trans_documentid || "",
        rel_trans_tradename:defaulttypesdi.default_rel_trans_tradename || "",
        rel_trans_name:defaulttypesdi.default_rel_trans_name || "",
        rel_trans_contactname:defaulttypesdi.default_rel_trans_contactname || "",
        rel_trans_roadtype_id:defaulttypesdi.default_rel_trans_roadtype_id!==0?defaulttypesdi.default_rel_trans_roadtype_id: Number(DEFAULTROADTYE),
        rel_trans_street:defaulttypesdi.default_rel_trans_street || "",
        rel_trans_country_id:defaulttypesdi.default_rel_trans_country_id!==0?defaulttypesdi.default_rel_trans_country_id:Number(DEFAULTCOUNTRY),
        rel_trans_country_name:defaulttypesdi.default_rel_trans_country_name!==""?defaulttypesdi.default_rel_trans_country_name:DEFAULTCOUNTRY_NAME,
        rel_trans_province_id:defaulttypesdi.default_rel_trans_province_id!==0?defaulttypesdi.default_rel_trans_province_id:Number(DEFAULTPROVINCE),
        rel_trans_province_name:defaulttypesdi.default_rel_trans_province_name!==""?defaulttypesdi.default_rel_trans_province_name:DEFAULTPROVINCE_NAME,
        rel_trans_postalcode_id:defaulttypesdi.default_rel_trans_postalcode_id!==0?defaulttypesdi.default_rel_trans_postalcode_id:Number(DEFAULTPOSTALCODE_ID),
        rel_trans_postalcode_code:defaulttypesdi.default_rel_trans_postalcode_code!==""?defaulttypesdi.default_rel_trans_postalcode_code:DEFAULTPOSTALCODE_CODE,
        rel_trans_postalcode_name:defaulttypesdi.default_rel_trans_postalcode_name!==""?defaulttypesdi.default_rel_trans_postalcode_name:DEFAULTPOSTALCODE_NAME,
        rel_trans_community_id:defaulttypesdi.default_rel_trans_community_id!==0?defaulttypesdi.default_rel_trans_community_id:Number(DEFAULTCOMMUNITY),
        rel_trans_community_name:defaulttypesdi.default_rel_trans_community_name!==""?defaulttypesdi.default_rel_trans_community_name:DEFAULTCOMMUNITY_NAME,
        rel_trans_phone:defaulttypesdi.default_rel_trans_phone || "",
        rel_trans_email:defaulttypesdi.default_rel_trans_email || "",
        rel_trans_nima:defaulttypesdi.default_rel_trans_nima || "",
        rel_trans_cnae:defaulttypesdi.default_rel_trans_cnae || "",
        rel_trans_inscription:defaulttypesdi.default_rel_trans_inscription || "",
        rel_trans_opt:defaulttypesdi.default_rel_trans_opt || 0,
        rel_trans_licenseplate:defaulttypesdi.default_rel_trans_licenseplate || "",
        rel_trans_economicactivity:defaulttypesdi.default_resp_prod_economicactivity || "",

        formrespprodstore_id:0,
        resp_prod_store_id:defaulttypesdi.default_resp_prod_id || 0,
        resp_prod_documnettype_id:defaulttypesdi.default_resp_prod_documnettype_id!==0?defaulttypesdi.default_resp_prod_documnettype_id:Number(DEFAULTTYPEOFDOCUMENT),
        resp_prod_documentid:defaulttypesdi.default_resp_prod_documentid || "",
        resp_prod_tradename:defaulttypesdi.default_resp_prod_tradename || "",
        resp_prod_name:defaulttypesdi.default_resp_prod_name || "",
        resp_prod_contactname:defaulttypesdi.default_resp_prod_contactname || "",
        resp_prod_roadtype_id:defaulttypesdi.default_resp_prod_roadtype_id!==0?defaulttypesdi.default_resp_prod_roadtype_id: Number(DEFAULTROADTYE),
        resp_prod_street:defaulttypesdi.default_resp_prod_street || "",
        resp_prod_country_id:defaulttypesdi.default_resp_prod_country_id!==0?defaulttypesdi.default_resp_prod_country_id:Number(DEFAULTCOUNTRY),
        resp_prod_country_name:defaulttypesdi.default_resp_prod_country_name!==""?defaulttypesdi.default_resp_prod_country_name:DEFAULTCOUNTRY_NAME,
        resp_prod_province_id:defaulttypesdi.default_resp_prod_province_id!==0?defaulttypesdi.default_resp_prod_province_id:Number(DEFAULTPROVINCE),
        resp_prod_province_name:defaulttypesdi.default_resp_prod_province_name!==""?defaulttypesdi.default_resp_prod_province_name:DEFAULTPROVINCE_NAME,
        resp_prod_postalcode_id:defaulttypesdi.default_resp_prod_postalcode_id!==0?defaulttypesdi.default_resp_prod_postalcode_id:Number(DEFAULTPOSTALCODE_ID),
        resp_prod_postalcode_code:defaulttypesdi.default_resp_prod_postalcode_code!==""?defaulttypesdi.default_resp_prod_postalcode_code:DEFAULTPOSTALCODE_CODE,
        resp_prod_postalcode_name:defaulttypesdi.default_resp_prod_postalcode_name!==""?defaulttypesdi.default_resp_prod_postalcode_name:DEFAULTPOSTALCODE_NAME,
        resp_prod_community_id:defaulttypesdi.default_resp_prod_community_id!==0?defaulttypesdi.default_resp_prod_community_id:Number(DEFAULTCOMMUNITY),
        resp_prod_community_name:defaulttypesdi.default_resp_prod_community_name!==""?defaulttypesdi.default_resp_prod_community_name:DEFAULTCOMMUNITY_NAME,
        resp_prod_phone:defaulttypesdi.default_resp_prod_phone || "",
        resp_prod_email:defaulttypesdi.default_resp_prod_email || "",
        resp_prod_nima:defaulttypesdi.default_resp_prod_nima || "",
        resp_prod_cnae:defaulttypesdi.default_resp_prod_cnae || "",
        resp_prod_inscription:defaulttypesdi.default_resp_prod_inscription || "",
        resp_prod_opt:defaulttypesdi.default_resp_prod_opt || "",
        resp_prod_licenseplate:defaulttypesdi.default_resp_prod_licenseplate || "",
        resp_prod_economicactivity:defaulttypesdi.default_resp_prod_economicactivity || "",

        opt_tras_shared:false,
        ori_tras_shared:false,
        aut_tras_shared:false,
        dest_tras_shared:false,
        aut_dest_shared:false,
        rel_trans_shared:false,
        resp_prod_shared:false,

        sendbyemail_form_opt_tras:false,
        sendbyemail_form_ori_tras:false,
        sendbyemail_form_aut_tras:false,
        sendbyemail_form_dest_tras:false,
        sendbyemail_form_aut_dest:false,
        sendbyemail_form_rel_trans:false,
        sendbyemail_form_resp_prod:false,

        signature_opt_tras:signature_default,
        signature_dest_tras:signature_default_des_tras,
        signature_refund:"" ,
        end_date_sheet:new Date(),
        widevalidity:false
      }));

      setHasbeenshared(false);
      setSharedLicensePlate(false);
      setSharedAmount(false);
      setShareddeliver_date(false); 
      setShareddate_accepted(false);
      setSharedreason_refund(false);
      setSharedaction_refund(false);
      setShareddate_refund(false);
      setSharedobservations(false);
      setSharedsignOptTras(false);
      setSharedsignDestTras(false);
      setSharedsignRefund(false);
    }
    return () => { isMounted = false };
  }, [dispatch,id,t,token,formForm.id,
      DEFAULTCOMMUNITY,DEFAULTROADTYE,DEFAULTTYPEOFDOCUMENT,DEFAULTCOMMUNITY_NAME,DEFAULTCOUNTRY_NAME,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPOSTALCODE_NAME,DEFAULTPROVINCE_NAME,
      DEFAULTCOUNTRY,DEFAULTPROVINCE,defaulttypesdi,defaultStore.id,useraccount_id,isLoadingData,signature_default,signature_default_des_tras]);  
 
  useEffect(() => {
    let isMounted = true; 
    const fetchDataNTs = async () => {
      try {
        const getData = await helpHttp().get5(ENDPOINT,`searchdcs/getlistnts`,token,defaultStore.id,
          (formForm.number_dt!==undefined && formForm.number_dt!==null && formForm.number_dt.replace(/[.\-/\\|]/g, "").trim()!=="")?formForm.number_dt.replace(/[.\-/\\|]/g, "").trim():"-1"); 
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setNtToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };  
    if (defaultStore.id && defaultStore.id!==null && defaultStore.id!=="" && defaultStore.id!=="0" && defaultStore.id!==0){
      fetchDataNTs();
    } 
    return () => { isMounted = false };
  }, [t,token,dispatch,i18n,roles,defaultStore.id,formForm.number_dt,expanded,DEFAULTPROVINCE,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPROVINCE_NAME,setFormForm]);
           
  return (
      <>
        {showModalFormSettings ? ( 
          <div className="container-fluid formgeneral-send-wrapper">
            <Box sx={{ bgcolor: '#ffffff', width: '920px'}}>
              <form onSubmit={handleCloseDataEditForm}>
                {/* HEADER */}
                <div className="formgeneral-card-header">
                  <div className="formgeneral-header-content">
                    <div className="formgeneral-header-title2">
                      {isLoadingErrorData?
                        <i className="fas fa-solid fa-exclamation fa-2x text-danger"/>:
                        (isLoadingData?
                        <CircularProgress sx={{ color : "#f6c23e"}}/>:
                        <i className="fas fa-regular fa-clipboard text-warning"></i>)} 
                        &nbsp;&nbsp;{id==="0"?t('Text_FORM_New'):t('Text_FORM_Edit')+': '+formForm.ownformdi_id}
                    </div>
                    <div className="email-card-actions">
                      {!isLoadingData && (
                        <>
                          <button type="button" className="formgeneral-send-btn" onClick={handleSubmitDataEditForm} >
                            {id==="0"?t('Button_Create'):t('Button_Update')}
                          </button>
                          <button type="button" className="formgeneral-cancel-btn" onClick={handleCloseDataEditForm} >
                            {t('Button_Cancel')}
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <br/>
                
                {/* FORM CARD */}
                {!isLoadingData ?
                <>
                  <div className="formgeneral-card-form">
                    <div className="email-header-title3">{t('Text_FORM_Line1')}</div>
                    <div className="email-header-title4">{t('Text_FORM_Line2')}</div>
                    <hr className="sidebar-divider d-none d-md-block"/>
                    <div className="row p-2">
                      <div className="form-group">  
                        <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_NUM_DI')} :</label>
                        &nbsp;&nbsp;&nbsp;&nbsp; 
                        <TextField
                          id="preiddoc_sheet" 
                          name="preiddoc_sheet"
                          value={formForm.preiddoc_sheet}
                          inputProps={{ style: {width: i18n.language==='es'?360:360,  fontSize: '18px'}, maxLength: 20 }}
                          InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                          label={errorsForm.preiddoc_sheet!=null?t(errorsForm.preiddoc_sheet):t('PlaceHolder_FORM_PREIDDOC_SHEET')}
                          placeholder={t('PlaceHolder_FORM_PREIDDOC_SHEET')}
                          variant="standard"
                          onBlur={handleBlurDataEditForm}
                          onChange={handleChangeDataEditForm}
                        />
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <label className="text-primary" style={{ fontSize: 18 }}> / </label>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <NumericFormat 
                          thousandSeparator={''} 
                          decimalSeparator={'.'} 
                          decimalScale= {0}
                          fixedDecimalScale= {true}
                          allowNegative= {false}
                          isAllowed={withValueCap}
                          id="sufiddoc_sheet" 
                          name="sufiddoc_sheet"
                          value={formForm.sufiddoc_sheet}
                          label={errorsForm.sufiddoc_sheet!=null?t(errorsForm.sufiddoc_sheet):t('PlaceHolder_FORM_SUFIDDOC_SHEET')}
                          placeholder={t('PlaceHolder_FORM_SUFIDDOC_SHEET')}
                          inputProps={{ style: {width: i18n.language==='es'?359:359,  fontSize: '18px'} }}
                          customInput={TextField}
                          onBlur={handleBlurDataEditFormAmount}
                          onChange={handleChangeDataEditFormAmount} 
                        />
                      </div>
                      {number_dt_view &&
                        <div className="form-group">   
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_NT_SHEET')} :</label>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <span style={{ position: "relative" }}>
                            <TextField
                              id="number_dt"
                              name="number_dt"
                              value={formForm.number_dt}
                              onChange={(e) => {
                                setFormForm(prev => ({
                                ...prev,
                                number_dt: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchNT(e.target.value);
                              }}
                              onKeyDown={handleKeyDownDNT}
                              onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                  handleBlur();
                                }
                              }}
                              label={errorsForm.number_dt!=null && errorsForm.number_dt!==""?t(errorsForm.number_dt):t('PlaceHolder_FORM_PREIDDOC_SHEET')}
                              placeholder={t('PlaceHolder_FORM_PREIDDOC_SHEET')}
                              variant="standard"
                              inputProps={{ style: {width: i18n.language==='es'?293:306,  fontSize: '18px'}, maxLength: 30 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              disabled={!number_dt_handle || hasbeenshared}
                            />  
                            {/* Desplegable dinámico */}
                            {filteredNT.length > 0 && (
                              <div
                                className="dropdown-class"
                                style={{
                                    position: "absolute",
                                    left:'0px',
                                    border: "2px solid #4e73df", // Borde azul (#4e73df)
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    maxWidth: "750px",
                                    overflowY: "auto",
                                    width: "100%",
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa", // Fondo gris claro
                                    zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                              >
                              {filteredNT.map((nt, index) => (
                                <MenuItem
                                  key={nt.id}
                                  onClick={() => handleSelectNT(nt)}
                                  style={{
                                    cursor: "pointer",
                                    padding: "8px",
                                    borderBottom: "1px solid #eee",
                                    fontSize: '18px',
                                    backgroundColor:
                                    index === highlightedIndexNT ? "#4e73df" : "transparent",
                                    color: index === highlightedIndexNT ? "white" : "black",
                                  }}
                                >
                                  {nt.number_dt}
                                </MenuItem>
                              ))}
                            </div>
                          )}
                          </span>
                          &nbsp;&nbsp;&nbsp;
                          <IconButton  size="large"  className="edit-select-button" onClick={searchFormNTs}>
                            <SearchIcon style={{fontSize: 28}}/>
                          </IconButton> 
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                        </div>
                      }
                      <div className="form-group">   
                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_DATE')} :</label>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <DesktopDatePicker
                            id="date_sheet" 
                            name="date_sheet"
                            value={ formForm.date_sheet!== null ? new Date(formForm.date_sheet):null}
                            format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                            inputProps={{ style: {width: 209}, maxLength: 100 }}
                            label={errorsForm.date_sheet!=null?t(errorsForm.date_sheet):t('PlaceHolder_FORM_DATE')}
                            onBlur={handleBlurSelectDate}
                            onChange={handleChangeSelectDate}
                            disabled={hasbeenshared} 
                            slotProps={{
                              textField: {
                                error: Boolean(errorsForm.date_sheet),
                                helperText: errorsForm.date_sheet ? t(errorsForm.date_sheet) : "",
                                placeholder: i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy",
                                sx: {
                                  width: i18n.language==="es"?209:209,
                                  "& .MuiInputBase-input": {
                                    fontSize: "18px",
                                    textAlign: "center" 
                                  }
                                },
                               InputProps: {
                                  style: { fontSize: "18px" }
                                },

                                InputLabelProps: {
                                  style: {
                                    fontSize: "18px",
                                    background: "#FFFFFF"
                                  }
                                },
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </div> 
                      <div className="form-group">   
                        <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Requirements_Validate')}</label>  
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <Checkbox
                          id="widevalidity" 
                          name="widevalidity"
                          checked={formForm.widevalidity}
                          onChange={handleChangeWideValidity}
                          variant="standard"
                           sx={{
                            '& .MuiSvgIcon-root': { color:"#4e73df",fontSize: 28 }, // Ajusta el tamaño del ícono
                          }} 
                        /> 
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Requirements_END_DATE')} :</label>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <DesktopDatePicker
                            id="end_date_sheet" 
                            name="end_date_sheet"
                            minDate={formForm.date_sheet!== null ? new Date(formForm.date_sheet): null}
                            value={ formForm.end_date_sheet!== null ? new Date(formForm.end_date_sheet):null}
                            format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                            inputProps={{ style: {width: i18n.language==="es"?260:260},alignItems:'center', maxLength: 100 }}
                            label={errorsForm.end_date_sheet!=null?t(errorsForm.end_date_sheet):t('Text_FORM_Requirements_END_DATE')}
                            onBlur={handleBlurSelectEndDate}
                            onChange={handleChangeSelectEndDate}
                            disabled={hasbeenshared || !formForm.widevalidity} 
                            slotProps={{
                              textField: {
                                placeholder: i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy",
                                helperText: t('Text_FORM_Requirements_HELPER_END_DATE'),
                                sx: {
                                  width: i18n.language==="es"?260:260,
                                  "& .MuiInputBase-input": {
                                    fontSize: "18px",
                                    textAlign: "center" 
                                  },
                                  "& .MuiFormHelperText-root": {
                                    color: "#d32f2f",
                                    fontSize: "12px",
                                  }
                                },
                               InputProps: {
                                  style: { fontSize: "18px" }
                                },

                                InputLabelProps: {
                                  style: {
                                    fontSize: "18px",
                                    background: "#FFFFFF"
                                  }
                                },
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </div>
                    </div>

                    {opt_tras_view && 
                      <Accordion className="accordionOptTras-root" expanded={expanded === 'panel1'} onChange={handleChange('panel1')} >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                            disabled={!opt_tras_expand}
                            className="accordionOptTras-backcolor"
                          >
                            <Typography className="accordionOptTras-heading">{t('Text_FORM_OPT_TRAS')} :</Typography>
                            <Typography className="accordionOptTras-secondaryHeading">
                              {formForm.opt_tras_tradename!==undefined && formForm.opt_tras_tradename!==null && formForm.opt_tras_tradename!==""?formForm.opt_tras_tradename:t('Text_NOT_REPORTING')}
                              {formForm.opt_tras_documentid!=="" && formForm.opt_tras_tradename===""?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_Tradename_Sheet_Required')} !!</span>:""}
                              {formForm.opt_tras_documentid!=="" && formForm.opt_tras_street!=="" && !formForm.opt_tras_postalcode_id?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_POSTALCODE_Opt_Tras_Required')} !!</span>:""}
                              {formForm.opt_tras_documentid!=="" && formForm.opt_tras_nima==="" ?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_NIMA_Opt_Tras_Required')} !!</span>:""}
                              {errorsForm.opt_tras_email!==undefined && errorsForm.opt_tras_email!==""?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Email_Sheet_Invalid')} !!</span>:""}
                              {(errorsForm.opt_tras_documentid!==undefined && errorsForm.opt_tras_documentid!=="") ||
                              (errorsForm.opt_tras_tradename!==undefined && errorsForm.opt_tras_tradename!=="") ||
                              (errorsForm.opt_tras_name!==undefined && errorsForm.opt_tras_name!=="") ||
                              (errorsForm.opt_tras_contactname!==undefined && errorsForm.opt_tras_contactname!=="") ||
                              (errorsForm.opt_tras_street!==undefined && errorsForm.opt_tras_street!=="") ||
                              (errorsForm.opt_tras_phone!==undefined && errorsForm.opt_tras_phone!=="") ||
                              (errorsForm.opt_tras_nima!==undefined && errorsForm.opt_tras_nima!=="") ||
                              (errorsForm.opt_tras_cnae!==undefined && errorsForm.opt_tras_cnae!=="") ||
                              (errorsForm.opt_tras_inscription!==undefined && errorsForm.opt_tras_inscription!=="") ||
                              (errorsForm.opt_tras_opt!==undefined && errorsForm.opt_tras_opt!=="") ||
                              (errorsForm.opt_tras_economicactivity!==undefined && errorsForm.opt_tras_economicactivity!=="") ||
                              (errorsForm.opt_tras_licenseplate!==undefined && errorsForm.opt_tras_licenseplate!==""
                              )
                              ?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Character_Sheet_Invalid')} !!</span>:""}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <div className="accordion-inner-box">
                              <FormCreateOrEditOptTras
                                formForm={formForm}
                                setFormForm={setFormForm}
                                setIsLoadingErrorData={setIsLoadingErrorData}
                                errorsForm={errorsForm}
                                setErrorsForm={setErrorsForm}
                                validateFormForm={validateFormForm}
                                documentTypesToSelect={documentTypesToSelect}
                                roadTypesToSelect={roadTypesToSelect}
                                communityToSelect={communityToSelect}
                                expanded={expanded}
                                optTypeToSelect={optTypeToSelect}
                                hasbeenshared={hasbeenshared}
                                />
                             </div>
                          </AccordionDetails>
                      </Accordion>
                    }
                    {ori_tras_view && 
                      <Accordion className="accordionOptTras-root" expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel2bh-content"
                          id="panel2bh-header"
                          disabled={!ori_tras_expand}
                          className="accordionOptTras-backcolor"
                        >
                          <Typography className="accordionOptTras-heading">{t('Text_FORM_ORI_TRAS')} : <span>{t('Text_FORM_ORI_TRAS_PROD')}</span></Typography>
                          <Typography className="accordionOptTras-secondaryHeading">
                            {formForm.ori_tras_tradename!==undefined && formForm.ori_tras_tradename!==null && formForm.ori_tras_tradename!==""?formForm.ori_tras_tradename:t('Text_NOT_REPORTING')}
                            {formForm.ori_tras_documentid!=="" && formForm.ori_tras_tradename===""?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_Tradename_Sheet_Required')} !!</span>:""}
                            {formForm.ori_tras_documentid!=="" && formForm.ori_tras_street!=="" && !formForm.ori_tras_postalcode_id?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_POSTALCODE_Ori_Tras_Required')} !!</span>:""}
                            {errorsForm.ori_tras_email!==undefined && errorsForm.ori_tras_email!==""?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Email_Sheet_Invalid')} !!</span>:""}
                            {(errorsForm.ori_tras_documentid!==undefined && errorsForm.ori_tras_documentid!=="") ||
                            (errorsForm.ori_tras_tradename!==undefined && errorsForm.ori_tras_tradename!=="") ||
                            (errorsForm.ori_tras_name!==undefined && errorsForm.ori_tras_name!=="") ||
                            (errorsForm.ori_tras_contactname!==undefined && errorsForm.ori_tras_contactname!=="") ||
                            (errorsForm.ori_tras_street!==undefined && errorsForm.ori_tras_street!=="") ||
                            (errorsForm.ori_tras_phone!==undefined && errorsForm.ori_tras_phone!=="") ||
                            (errorsForm.ori_tras_nima!==undefined && errorsForm.ori_tras_nima!=="") ||
                            (errorsForm.ori_tras_cnae!==undefined && errorsForm.ori_tras_cnae!=="") ||
                            (errorsForm.ori_tras_inscription!==undefined && errorsForm.ori_tras_inscription!=="") ||
                            (errorsForm.ori_tras_opt!==undefined && errorsForm.ori_tras_opt!=="") ||
                            (errorsForm.ori_tras_economicactivity!==undefined && errorsForm.ori_tras_economicactivity!=="") ||
                            (errorsForm.ori_tras_licenseplate!==undefined && errorsForm.ori_tras_licenseplate!=="")
                            ?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Character_Sheet_Invalid')} !!</span>:""}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div className="accordion-inner-box">
                            <FormCreateOrEditOriTras
                              formForm={formForm}
                              setFormForm={setFormForm}
                              setIsLoadingErrorData={setIsLoadingErrorData}
                              errorsForm={errorsForm}
                              setErrorsForm={setErrorsForm}
                              validateFormForm={validateFormForm}
                              documentTypesToSelect={documentTypesToSelect}
                              roadTypesToSelect={roadTypesToSelect}
                              communityToSelect={communityToSelect}
                              expanded={expanded}
                              optTypeToSelect={optTypeToSelect}
                              hasbeenshared={hasbeenshared}
                            />
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    }
                    {aut_tras_view && 
                      <Accordion className="accordionOptTras-root" expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel3bh-content"
                          id="panel3bh-header"
                          disabled={!aut_tras_expand}
                          className="accordionOptTras-backcolor"
                        >
                          <Typography className="accordionOptTras-heading">{t('Text_FORM_ORI_TRAS')} : <span>{t('Text_FORM_ORI_TRAS_EMPR')}</span></Typography>
                          <Typography className="accordionOptTras-secondaryHeading">
                            {formForm.aut_tras_tradename!==undefined && formForm.aut_tras_tradename!==null && formForm.aut_tras_tradename!==""?formForm.aut_tras_tradename:t('Text_NOT_REPORTING')}
                            {formForm.aut_tras_documentid!=="" && formForm.aut_tras_tradename===""?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_Tradename_Sheet_Required')} !!</span>:""}
                            {formForm.aut_tras_documentid!=="" && formForm.aut_tras_street!=="" && !formForm.aut_tras_postalcode_id?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_POSTALCODE_Aut_Tras_Required')} !!</span>:""}
                            {errorsForm.aut_tras_email!==undefined && errorsForm.aut_tras_email!==""?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Email_Sheet_Invalid')} !!</span>:""}
                            {(errorsForm.aut_tras_documentid!==undefined && errorsForm.aut_tras_documentid!=="") ||
                            (errorsForm.aut_tras_tradename!==undefined && errorsForm.aut_tras_tradename!=="") ||
                            (errorsForm.aut_tras_name!==undefined && errorsForm.aut_tras_name!=="") ||
                            (errorsForm.aut_tras_contactname!==undefined && errorsForm.aut_tras_contactname!=="") ||
                            (errorsForm.aut_tras_street!==undefined && errorsForm.aut_tras_street!=="") ||
                            (errorsForm.aut_tras_phone!==undefined && errorsForm.aut_tras_phone!=="") ||
                            (errorsForm.aut_tras_nima!==undefined && errorsForm.aut_tras_nima!=="") ||
                            (errorsForm.aut_tras_cnae!==undefined && errorsForm.aut_tras_cnae!=="") ||
                            (errorsForm.aut_tras_inscription!==undefined && errorsForm.aut_tras_inscription!=="") ||
                            (errorsForm.aut_tras_opt!==undefined && errorsForm.aut_tras_opt!=="") ||
                            (errorsForm.aut_tras_economicactivity!==undefined && errorsForm.aut_tras_economicactivity!=="") ||
                            (errorsForm.aut_tras_licenseplate!==undefined && errorsForm.aut_tras_licenseplate!=="")
                            ?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Character_Sheet_Invalid')} !!</span>:""}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div className="accordion-inner-box">
                            <FormCreateOrEditAutTras
                              formForm={formForm}
                              setFormForm={setFormForm}
                              setIsLoadingErrorData={setIsLoadingErrorData}
                              errorsForm={errorsForm}
                              setErrorsForm={setErrorsForm}
                              validateFormForm={validateFormForm}
                              documentTypesToSelect={documentTypesToSelect}
                              roadTypesToSelect={roadTypesToSelect}
                              communityToSelect={communityToSelect}
                              expanded={expanded}
                              optTypeToSelect={optTypeToSelect}
                              hasbeenshared={hasbeenshared}
                            />
                          </div>
                        </AccordionDetails>
                        
                      </Accordion>
                    }
                    {dest_tras_view && 
                      <Accordion className="accordionOptTras-root" expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel4bh-content"
                          id="panel4bh-header"
                          disabled={!dest_tras_expand}
                          className="accordionOptTras-backcolor"
                        >
                          <Typography className="accordionOptTras-heading">{t('Text_FORM_DEST_TRAS')} : <span>{t('Text_FORM_DEST_TRAS_PROD')}</span></Typography>
                          <Typography className="accordionOptTras-secondaryHeading">
                            {formForm.dest_tras_tradename!==undefined && formForm.dest_tras_tradename!==null && formForm.dest_tras_tradename!==""?formForm.dest_tras_tradename:t('Text_NOT_REPORTING')}
                            {formForm.dest_tras_documentid!=="" && formForm.dest_tras_tradename===""?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_Tradename_Sheet_Required')} !!</span>:""}
                            {formForm.dest_tras_documentid!=="" && formForm.dest_tras_street!=="" && !formForm.dest_tras_postalcode_id?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_POSTALCODE_Dest_Tras_Required')} !!</span>:""}
                            {errorsForm.dest_tras_email!==undefined && errorsForm.dest_tras_email!==""?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Email_Sheet_Invalid')} !!</span>:""}
                            {(errorsForm.dest_tras_documentid!==undefined && errorsForm.dest_tras_documentid!=="") ||
                            (errorsForm.dest_tras_tradename!==undefined && errorsForm.dest_tras_tradename!=="") ||
                            (errorsForm.dest_tras_name!==undefined && errorsForm.dest_tras_name!=="") ||
                            (errorsForm.dest_tras_contactname!==undefined && errorsForm.dest_tras_contactname!=="") ||
                            (errorsForm.dest_tras_street!==undefined && errorsForm.dest_tras_street!=="") ||
                            (errorsForm.dest_tras_phone!==undefined && errorsForm.dest_tras_phone!=="") ||
                            (errorsForm.dest_tras_nima!==undefined && errorsForm.dest_tras_nima!=="") ||
                            (errorsForm.dest_tras_cnae!==undefined && errorsForm.dest_tras_cnae!=="") ||
                            (errorsForm.dest_tras_inscription!==undefined && errorsForm.dest_tras_inscription!=="") ||
                            (errorsForm.dest_tras_opt!==undefined && errorsForm.dest_tras_opt!=="") ||
                            (errorsForm.dest_tras_economicactivity!==undefined && errorsForm.dest_tras_economicactivity!=="") ||
                            (errorsForm.dest_tras_licenseplate!==undefined && errorsForm.dest_tras_licenseplate!=="")
                            ?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Character_Sheet_Invalid')} !!</span>:""}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div className="accordion-inner-box">
                            <FormCreateOrEditDestTras
                              formForm={formForm}
                              setFormForm={setFormForm}
                              setIsLoadingErrorData={setIsLoadingErrorData}
                              errorsForm={errorsForm}
                              setErrorsForm={setErrorsForm}
                              validateFormForm={validateFormForm}
                              documentTypesToSelect={documentTypesToSelect}
                              roadTypesToSelect={roadTypesToSelect}
                              communityToSelect={communityToSelect}
                              expanded={expanded} 
                              optTypeToSelect={optTypeToSelect}
                              hasbeenshared={hasbeenshared}
                            />
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    }
                    {aut_dest_view &&   
                      <Accordion className="accordionOptTras-root" expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel5bh-content"
                          id="panel5bh-header"
                          disabled={!aut_dest_expand}
                          className="accordionOptTras-backcolor"
                        >
                          <Typography className="accordionOptTras-heading">{t('Text_FORM_DEST_TRAS')} : <span>{t('Text_FORM_DEST_TRAS_EMPR')}</span></Typography>
                          <Typography className="accordionOptTras-secondaryHeading">
                          {formForm.aut_dest_tradename!==undefined && formForm.aut_dest_tradename!==null && formForm.aut_dest_tradename!==""?formForm.aut_dest_tradename:t('Text_NOT_REPORTING')}
                          {formForm.aut_dest_documentid!=="" && formForm.aut_dest_tradename===""?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_Tradename_Sheet_Required')} !!</span>:""}
                          {formForm.aut_dest_documentid!=="" && formForm.aut_dest_street!=="" && !formForm.aut_dest_postalcode_id?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_POSTALCODE_Aut_Dest_Required')} !!</span>:""}
                          {errorsForm.aut_dest_email!==undefined && errorsForm.aut_dest_email!==""?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Email_Sheet_Invalid')} !!</span>:""}
                          {(errorsForm.aut_dest_documentid!==undefined && errorsForm.aut_dest_documentid!=="") ||
                          (errorsForm.aut_dest_tradename!==undefined && errorsForm.aut_dest_tradename!=="") ||
                          (errorsForm.aut_dest_name!==undefined && errorsForm.aut_dest_name!=="") ||
                          (errorsForm.aut_dest_contactname!==undefined && errorsForm.aut_dest_contactname!=="") ||
                          (errorsForm.aut_dest_street!==undefined && errorsForm.aut_dest_street!=="") ||
                          (errorsForm.aut_dest_phone!==undefined && errorsForm.aut_dest_phone!=="") ||
                          (errorsForm.aut_dest_nima!==undefined && errorsForm.aut_dest_nima!=="") ||
                          (errorsForm.aut_dest_cnae!==undefined && errorsForm.aut_dest_cnae!=="") ||
                          (errorsForm.aut_dest_inscription!==undefined && errorsForm.aut_dest_inscription!=="") ||
                          (errorsForm.aut_dest_opt!==undefined && errorsForm.aut_dest_opt!=="") ||
                          (errorsForm.aut_dest_economicactivity!==undefined && errorsForm.aut_dest_economicactivity!=="") ||
                          (errorsForm.aut_dest_licenseplate!==undefined && errorsForm.aut_dest_licenseplate!=="")
                          ?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Character_Sheet_Invalid')} !!</span>:""}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div className="accordion-inner-box">
                            <FormCreateOrEditAutDest
                              formForm={formForm}
                              setFormForm={setFormForm}
                              setIsLoadingErrorData={setIsLoadingErrorData}
                              errorsForm={errorsForm}
                              setErrorsForm={setErrorsForm}
                              validateFormForm={validateFormForm}
                              documentTypesToSelect={documentTypesToSelect}
                              roadTypesToSelect={roadTypesToSelect}
                              communityToSelect={communityToSelect}
                              expanded={expanded}
                              optTypeToSelect={optTypeToSelect}
                              hasbeenshared={hasbeenshared}
                            />
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    } 
                    <div className="row p-2"> 
                      <div className="form-group">   
                        <h6 className="h7NewStyle mb-2">{t('Text_FORM_CHARAC')}</h6>
                        {/* Divider */}
                        <hr className="sidebar-divider d-none d-md-block"/>
                        <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CODE_LER')} :</label>
                        &nbsp;&nbsp;&nbsp;&nbsp; 
                        <TextField
                          id="codeler_code" 
                          name="codeler_code"
                          value={formForm.codeler_code}
                          inputProps={{ style: {width: i18n.language==='es'?150:150,  fontSize: '18px'}, maxLength: 20 }}
                          InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                          label={errorsForm.codeler_code!=null?t(errorsForm.codeler_code):t('PlaceHolder_FORM_CODE_LER')}
                          placeholder={t('PlaceHolder_FORM_CODE_LER')}
                          variant="standard"
                          onBlur={handleBlurDataEditForm}
                          onChange={handleChangeDataEditForm}
                          disabled={hasbeenshared} />
                        &nbsp;&nbsp;&nbsp;&nbsp; 
                        <TextField
                          id={i18n.language==='es'?"codeler_namees":"codeler_nameen"}
                          name={i18n.language==='es'?"codeler_namees":"codeler_nameen"}
                          value={i18n.language==='es'?formForm.codeler_namees:formForm.codeler_nameen}
                          inputProps={{ style: {width: i18n.language==='es'?283:305,  fontSize: '18px'}, maxLength: 200 }}
                          InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                          label={t('Text_FORM_CODE_DESCRIPTION_TITLE')}
                          placeholder={t('Text_FORM_CODE_DESCRIPTION_TITLE')}
                          variant="standard"
                          onBlur={handleBlurDataEditForm}
                          onChange={handleChangeDataEditForm}
                          disabled/>
                        &nbsp;&nbsp;
                        <IconButton  size="small"  className="deletesmall-select-button" disabled={hasbeenshared} onClick={deleteDataCodeLer}>
                            <DeleteIcon style={{fontSize: 28}}/>
                        </IconButton>
                        &nbsp;&nbsp;
                        {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_CodeLERS'))&&
                          <IconButton  size="small"  className="edit-select-button" disabled={hasbeenshared} onClick={searchFormCodeLer}>
                            <SearchIcon style={{fontSize: 28}}/>
                          </IconButton>
                        }
                      </div>
                    </div>
                    {code_description_view && 
                      <div className="row p-2"> 
                        <div className="form-group">   
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CODE_DESCRIPTION')} :</label>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <TextField
                            id="description_code" 
                            name="description_code"
                            value={formForm.description_code}
                            inputProps={{ style: {width: i18n.language==='es'?150:150,  fontSize: '18px'}, maxLength: 20 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                            label={errorsForm.description_code!=null?t(errorsForm.description_code):t('PlaceHolder_FORM_CODE_DESCRIPTION')}
                            placeholder={t('PlaceHolder_FORM_CODE_DESCRIPTION')}
                            variant="standard"
                            onBlur={handleBlurDataEditForm}
                            onChange={handleChangeDataEditForm}
                            disabled={!code_description_handle || hasbeenshared}/>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <TextField
                            id={i18n.language==='es'?"description_namees":"description_nameen"}
                            name={i18n.language==='es'?"description_namees":"description_nameen"}
                            value={i18n.language==='es'?formForm.description_namees:formForm.description_nameen}
                            inputProps={{ style: {width: i18n.language==='es'?440:458,  fontSize: '18px'}, maxLength: 200 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                            label={t('Text_FORM_CODE_DESCRIPTION_TITLE')}
                            placeholder={t('Text_FORM_CODE_DESCRIPTION_TITLE')}
                            variant="standard"
                            onBlur={handleBlurDataEditForm}
                            onChange={handleChangeDataEditForm}
                            disabled/>
                          &nbsp;&nbsp;
                          {code_description_handle&&
                            <>
                              <IconButton  size="small"  className="deletesmall-select-button" disabled={hasbeenshared} onClick={deleteDataDescription}>
                                  <DeleteIcon style={{fontSize: 28}}/>
                              </IconButton>
                              &nbsp;&nbsp;
                              {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Descriptions'))&&
                                <IconButton  size="small"  className="edit-select-button" disabled={hasbeenshared}  onClick={searchFormDescription}>
                                  <SearchIcon style={{fontSize: 28}}/>
                                </IconButton>
                              }
                            </>
                          }
                        </div>
                      </div>
                    }  
                    {(code_treatmenttype_origin_view ||  code_processtype_origin_view) && 
                      <div className="row p-2"> 
                          <div className="form-group">   
                            { code_treatmenttype_origin_view &&
                              <>
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CODE_TREATMENT_ORIGIN')} :</label>
                                &nbsp;&nbsp;&nbsp;&nbsp; 
                                <TextField
                                  id="treatmenttypeorigin_id"
                                  name="treatmenttypeorigin_id"
                                  value={ (formForm.treatmenttypeorigin_id === undefined || formForm.treatmenttypeorigin_id ===null || formForm.treatmenttypeorigin_id ===""
                                        || formForm.treatmenttypeorigin_id ==="0" || formForm.treatmenttypeorigin_id ===0)?0:formForm.treatmenttypeorigin_id}
                                  InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                                  inputProps={{ style: {width: (code_treatmenttype_origin_view &&  code_processtype_origin_view)?i18n.language==='es'?101:113:i18n.language==='es'?555:567 ,  fontSize: '18px'}, maxLength: 100, }}
                                  variant="outlined"
                                  onBlur={handleBlurSelectTreatmentTypeOrigin}
                                  onChange={handleChangeSelectTreatmentTypeOrigin}
                                  disabled={!code_treatmenttype_origin_handle || hasbeenshared}
                                  select
                                  SelectProps={{
                                    native: true,
                                    value: (formForm.treatmenttypeorigin_id === undefined || formForm.treatmenttypeorigin_id ===null || formForm.treatmenttypeorigin_id ===""
                                        || formForm.treatmenttypeorigin_id ==="0" || formForm.treatmenttypeorigin_id ===0)?0: formForm.treatmenttypeorigin_id
                                  }}>
                                  <option key={0} value=""/>
                                  {treatmenttypeToSelect.map((option) => (
                                  <option key={option.id} value={option.id}>
                                      {i18n.language==="es"?option.code+" - "+option.namees.substring(0,80):option.code+" - "+option.nameen.substring(0,80)}
                                  </option>
                                  ))}
                                </TextField>
                                {code_processtype_origin_view && <>  &nbsp;&nbsp;&nbsp;&nbsp;</> }
                              </>
                            }
                            { code_processtype_origin_view &&
                              <>
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CODE_PROCESS_ORIGIN')} :</label>
                                &nbsp;&nbsp;&nbsp;&nbsp; 
                                <TextField
                                  id="processtypepeorigin_id"
                                  name="processtypepeorigin_id"
                                  value={ (formForm.processtypepeorigin_id === undefined || formForm.processtypepeorigin_id ===null || formForm.processtypepeorigin_id ===""
                                        || formForm.processtypepeorigin_id ==="0" || formForm.processtypepeorigin_id ===0)?0:formForm.processtypepeorigin_id}
                                  inputProps={{ style: {width: (code_treatmenttype_origin_view &&  code_processtype_origin_view)?i18n.language==='es'?101:113:i18n.language==='es'?555:567,  fontSize: '18px'}, maxLength: 100, }}
                                  InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                                  variant="outlined"
                                  onBlur={handleBlurSelectProcessTypeOrigin}
                                  onChange={handleChangeSelectProcessTypeOrigin}
                                  disabled={!code_processtype_origin_handle|| hasbeenshared}
                                  select
                                  SelectProps={{
                                    native: true,
                                    value: (formForm.processtypepeorigin_id === undefined || formForm.processtypepeorigin_id ===null || formForm.processtypepeorigin_id ===""
                                        || formForm.processtypepeorigin_id ==="0" || formForm.processtypepeorigin_id ===0)?0: formForm.processtypepeorigin_id
                                  }}>
                                  <option key={0} value=""/>
                                  {processtypeToSelect.map((option) => (
                                  <option key={option.id} value={option.id}>
                                      {i18n.language==="es"?option.code+" - "+option.namees.substring(0,80):option.code+" - "+option.nameen.substring(0,80)}
                                  </option>
                                  ))}
                                </TextField>
                              </>
                            }
                          </div>
                        </div>
                        
                    }
                    {(code_treatmenttype_destine_view ||  code_processtype_destine_view) && 
                      <div className="row p-2"> 
                          <div className="form-group">   
                            { code_treatmenttype_destine_view &&
                              <>
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CODE_TREATMENT_DESTINE')} :</label>
                                &nbsp;&nbsp;&nbsp;&nbsp; 
                                <TextField
                                  id="treatmenttypedestine_id"
                                  name="treatmenttypedestine_id"
                                  value={ (formForm.treatmenttypedestine_id === undefined || formForm.treatmenttypedestine_id ===null || formForm.treatmenttypedestine_id ===""
                                        || formForm.treatmenttypedestine_id ==="0" || formForm.treatmenttypedestine_id ===0)?0:formForm.treatmenttypedestine_id}
                                  inputProps={{ style: {width: (code_treatmenttype_destine_view &&  code_processtype_destine_view)?i18n.language==='es'?90:73:i18n.language==='es'?542:525,  fontSize: '18px'}, maxLength: 100, }}
                                  InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                                  variant="outlined"
                                  onBlur={handleBlurSelectTreatmentTypeDestine}
                                  onChange={handleChangeSelectTreatmentTypeDestine}
                                  disabled={!code_treatmenttype_destine_handle || hasbeenshared}
                                  select
                                  SelectProps={{
                                    native: true,
                                    value: (formForm.treatmenttypedestine_id === undefined || formForm.treatmenttypedestine_id ===null || formForm.treatmenttypedestine_id ===""
                                        || formForm.treatmenttypedestine_id ==="0" || formForm.treatmenttypedestine_id ===0)?0: formForm.treatmenttypedestine_id
                                  }}>
                                  <option key={0} value=""/>
                                  {treatmenttypeToSelect.map((option) => (
                                  <option key={option.id} value={option.id}>
                                      {i18n.language==="es"?option.code+" - "+option.namees.substring(0,80):option.code+" - "+option.nameen.substring(0,80)}
                                  </option>
                                  ))}
                                </TextField>
                                {code_processtype_destine_view && <>&nbsp;&nbsp;&nbsp;&nbsp;</> }
                              </>
                            }
                            { code_processtype_destine_view &&
                              <>
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CODE_PROCESS_DESTINE')} :</label>
                                &nbsp;&nbsp;&nbsp;&nbsp; 
                                <TextField
                                  id="processtypedestine_id"
                                  name="processtypedestine_id"
                                  value={ (formForm.processtypedestine_id === undefined || formForm.processtypedestine_id ===null || formForm.processtypedestine_id ===""
                                        || formForm.processtypedestine_id ==="0" || formForm.processtypedestine_id ===0)?0:formForm.processtypedestine_id}
                                  inputProps={{ style: {width: (code_treatmenttype_destine_view &&  code_processtype_destine_view)?i18n.language==='es'?91:74:i18n.language==='es'?542:525,  fontSize: '18px'}, maxLength: 100, }}
                                  InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                                  variant="outlined"
                                  onBlur={handleBlurSelectProcessTypeDestine}
                                  onChange={handleChangeSelectProcessTypeDestine}
                                  disabled={!code_processtype_destine_handle || hasbeenshared}
                                  select
                                  SelectProps={{
                                    native: true,
                                    value: (formForm.processtypedestine_id === undefined || formForm.processtypedestine_id ===null || formForm.processtypedestine_id ===""
                                        || formForm.processtypedestine_id ==="0" || formForm.processtypedestine_id ===0)?0: formForm.processtypedestine_id
                                  }}>
                                  <option key={0} value=""/>
                                  {processtypeToSelect.map((option) => (
                                  <option key={option.id} value={option.id}>
                                      {i18n.language==="es"?option.code+" - "+option.namees.substring(0,80):option.code+" - "+option.nameen.substring(0,80)}
                                  </option>
                                  ))}
                                </TextField>
                              </>
                            }
                          </div>
                        </div>
                    }
                    {code_dangerousness_view && 
                      <div className="row p-2"> 
                        <div className="form-group">   
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CODE_DANGEROUSNESS')} :</label>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <TextField
                            id="dangerousness_id"
                            name="dangerousness_id"
                            value={ (formForm.dangerousness_id === undefined || formForm.dangerousness_id ===null || formForm.dangerousness_id ===""
                                  || formForm.dangerousness_id ==="0" || formForm.dangerousness_id ===0)?0:formForm.dangerousness_id}
                            inputProps={{ style: {width: i18n.language==='es'?611:600,  fontSize: '18px'}, maxLength: 100, }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                            variant="outlined"
                            onBlur={handleBlurSelectDangerousness}
                            onChange={handleChangeSelectDangerousness}
                            disabled={!code_dangerousness_handle || hasbeenshared}
                            select
                            SelectProps={{
                              native: true,
                              value: (formForm.dangerousness_id === undefined || formForm.dangerousness_id ===null || formForm.dangerousness_id ===""
                                  || formForm.dangerousness_id ==="0" || formForm.dangerousness_id ===0)?0: formForm.dangerousness_id
                            }}>
                            <option key={0} value=""/>
                            {dangerousness.map((option) => (
                            <option key={option.id} value={option.id}>
                                {i18n.language==="es"?option.namees.substring(0,90):option.nameen.substring(0,90)}
                            </option>
                            ))}
                          </TextField>
                        </div>
                      </div>
                    }
                    
                    {charac_danger_view && 
                      <div className="row p-2"> 
                        <div className="form-group">   
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CHARAC_DANGER')} :</label>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <TextField
                            id="charac_danger" 
                            name="charac_danger"
                            value={formForm.charac_danger}
                            inputProps={{ style: {width: i18n.language==='es'?595:580}, maxLength: 200 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            label={errorsForm.charac_danger!=null?t(errorsForm.charac_danger):t('PlaceHolder_FORM_CHARAC_DANGER')}
                            placeholder={t('PlaceHolder_FORM_CHARAC_DANGER')}
                            variant="standard"
                            onBlur={handleBlurDataEditForm}
                            onChange={handleChangeDataEditForm}
                            disabled={!charac_danger_handle || hasbeenshared}/>
                        </div>
                      </div>
                    }
                    
                    <div className="row p-2"> 
                      <div className="form-group">
                        <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_AMOUNT')} :</label>
                        &nbsp;&nbsp;&nbsp;&nbsp; 
                        <NumericFormat 
                          thousandSeparator={','} 
                          decimalSeparator={'.'} 
                          decimalScale= {2}
                          fixedDecimalScale= {true}
                          allowNegative= {false}
                          isAllowed={withValueCap}
                          id="amount" 
                          name="amount"
                          suffix={" kg"}
                          value={formForm.amount}
                          label={errorsForm.amount!=null?t(errorsForm.amount):t('PlaceHolder_FORM_AMOUNT')}
                          placeholder={t('PlaceHolder_FORM_AMOUNT')}
                          inputProps={{ style: {width: i18n.language==='es'?200:200} }}
                          InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                          customInput={TextField}
                          error={Boolean(errorsForm.delivery_quantity)}
                          helperText={errorsForm.delivery_quantity ? t(errorsForm.delivery_quantity) : ""}
                          onBlur={handleBlurDataEditFormAmount}
                          onChange={handleChangeDataEditFormAmount} 
                          disabled={sharedAmount} 
                        />
                      </div>
                    </div>
                    
                    {rel_trans_view && 
                      <Accordion className="accordionOptTras-root" expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel6bh-content"
                          id="panel6bh-header"
                          disabled={!rel_trans_expand}
                          className="accordionOptTras-backcolor"
                        >
                            <Typography className="accordionOptTras-heading">{t('Text_FORM_Carrier')} : </Typography>
                            <Typography className="accordionOptTras-secondaryHeading">
                              {formForm.rel_trans_tradename!==undefined && formForm.rel_trans_tradename!==null && formForm.rel_trans_tradename!==""?formForm.rel_trans_tradename:t('Text_NOT_REPORTING')}
                              {formForm.rel_trans_documentid!=="" && formForm.rel_trans_tradename===""?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_Tradename_Sheet_Required')} !!</span>:""}
                              {formForm.rel_trans_documentid!=="" && formForm.rel_trans_street!=="" && !formForm.rel_trans_postalcode_id?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_POSTALCODE_Rel_Trans_Required')} !!</span>:""}
                              {errorsForm.rel_trans_email!==undefined && errorsForm.rel_trans_email!==""?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Email_Sheet_Invalid')} !!</span>:""}
                              {(errorsForm.rel_trans_documentid!==undefined && errorsForm.rel_trans_documentid!=="") ||
                              (errorsForm.rel_trans_tradename!==undefined && errorsForm.rel_trans_tradename!=="") ||
                              (errorsForm.rel_trans_name!==undefined && errorsForm.rel_trans_name!=="") ||
                              (errorsForm.rel_trans_contactname!==undefined && errorsForm.rel_trans_contactname!=="") ||
                              (errorsForm.rel_trans_street!==undefined && errorsForm.rel_trans_street!=="") ||
                              (errorsForm.rel_trans_phone!==undefined && errorsForm.rel_trans_phone!=="") ||
                              (errorsForm.rel_trans_nima!==undefined && errorsForm.rel_trans_nima!=="") ||
                              (errorsForm.rel_trans_cnae!==undefined && errorsForm.rel_trans_cnae!=="") ||
                              (errorsForm.rel_trans_inscription!==undefined && errorsForm.rel_trans_inscription!=="") ||
                              (errorsForm.rel_trans_opt!==undefined && errorsForm.rel_trans_opt!=="") ||
                              (errorsForm.rel_trans_economicactivity!==undefined && errorsForm.rel_trans_economicactivity!=="") ||
                              (errorsForm.rel_trans_licenseplate!==undefined && errorsForm.rel_trans_licenseplate!=="")
                              ?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Character_Sheet_Invalid')} !!</span>:""}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div className="accordion-inner-box">
                            <FormCreateOrEditRelTrans
                                formForm={formForm}
                                setFormForm={setFormForm}
                                setIsLoadingErrorData={setIsLoadingErrorData}
                                errorsForm={errorsForm}
                                setErrorsForm={setErrorsForm}
                                validateFormForm={validateFormForm}
                                documentTypesToSelect={documentTypesToSelect}
                                roadTypesToSelect={roadTypesToSelect}
                                communityToSelect={communityToSelect}
                                expanded={expanded}
                                optTypeToSelect={optTypeToSelect}
                                hasbeenshared={hasbeenshared}
                                sharedLicensePlate={sharedLicensePlate}
                            />
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    }
                    {resp_prod_view && 
                      <Accordion className="accordionOptTras-root" expanded={expanded === 'panel7'} onChange={handleChange('panel7')}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel7bh-content"
                          id="panel7bh-header"
                          disabled={!resp_prod_expand}
                          className="accordionOptTras-backcolor"
                        >
                          <Typography className="accordionOptTras-heading">{t('Text_FORM_SRAP')} : <span>{t('Text_FORM_SRAP_DESCRIPTION')}</span></Typography>
                          <Typography className="accordionOptTras-secondaryHeading">
                            {formForm.resp_prod_tradename!==undefined && formForm.resp_prod_tradename!==null && formForm.resp_prod_tradename!==""?formForm.resp_prod_tradename:t('Text_NOT_REPORTING')}
                            {formForm.resp_prod_documentid!=="" && formForm.resp_prod_tradename===""?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_Tradename_Sheet_Required')} !!</span>:""}
                            {formForm.resp_prod_documentid!=="" && formForm.resp_prod_street!=="" && !formForm.resp_prod_postalcode_id?<span className="accordionOptTras-thirdHeading"> - {t('Text_Field_POSTALCODE_Resp_Prod_Required')} !!</span>:""}
                            {errorsForm.resp_prod_email!==undefined && errorsForm.resp_prod_email!==""?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Email_Sheet_Invalid')} !!</span>:""}
                            {(errorsForm.resp_prod_documentid!==undefined && errorsForm.resp_prod_documentid!=="") ||
                            (errorsForm.resp_prod_tradename!==undefined && errorsForm.resp_prod_tradename!=="") ||
                            (errorsForm.resp_prod_name!==undefined && errorsForm.resp_prod_name!=="") ||
                            (errorsForm.resp_prod_contactname!==undefined && errorsForm.resp_prod_contactname!=="") ||
                            (errorsForm.resp_prod_street!==undefined && errorsForm.resp_prod_street!=="") ||
                            (errorsForm.resp_prod_phone!==undefined && errorsForm.resp_prod_phone!=="") ||
                            (errorsForm.resp_prod_nima!==undefined && errorsForm.resp_prod_nima!=="") ||
                            (errorsForm.resp_prod_cnae!==undefined && errorsForm.resp_prod_cnae!=="") ||
                            (errorsForm.resp_prod_inscription!==undefined && errorsForm.resp_prod_inscription!=="") ||
                            (errorsForm.resp_prod_opt!==undefined && errorsForm.resp_prod_opt!=="") ||
                            (errorsForm.resp_prod_economicactivity!==undefined && errorsForm.resp_prod_economicactivity!=="") ||
                            (errorsForm.resp_prod_licenseplate!==undefined && errorsForm.resp_prod_licenseplate!=="")
                            ?<span className="accordionOptTras-thirdHeading">  -  {t('Text_Field_Character_Sheet_Invalid')} !!</span>:""}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div className="accordion-inner-box">
                            <FormCreateOrEditRespProd
                                formForm={formForm}
                                setFormForm={setFormForm}
                                setIsLoadingErrorData={setIsLoadingErrorData}
                                errorsForm={errorsForm}
                                setErrorsForm={setErrorsForm}
                                validateFormForm={validateFormForm}
                                documentTypesToSelect={documentTypesToSelect}
                                roadTypesToSelect={roadTypesToSelect}
                                communityToSelect={communityToSelect}
                                expanded={expanded}
                                optTypeToSelect={optTypeToSelect}
                                hasbeenshared={hasbeenshared}
                            />
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    }
                    <div className="row p-2"> 
                      <div className="form-group">   
                        <h6 className="h7NewStyle mb-2">{t('Text_FORM_ACCEPTED')}</h6>
                        {/* Divider */}
                        <hr className="sidebar-divider d-none d-md-block"/>
                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Deliver_date')} :</label>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <DesktopDatePicker
                            id="deliver_date" 
                            name="deliver_date"
                            value={ formForm.deliver_date!== null ? new Date(formForm.deliver_date): null}
                            label={errorsForm.deliver_date!=null?t(errorsForm.deliver_date):t('PlaceHolder_FORM_Deliver_date')}
                            format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                            onBlur={handleBlurSelectDateDeliver}
                            onChange={handleChangeSelectDateDeliver} 
                            disabled={shareddeliver_date} 
                            slotProps={{
                              textField: {
                                error: Boolean(errorsForm.deliver_date),
                                helperText: errorsForm.deliver_date ? t(errorsForm.deliver_date) : "",
                                placeholder: i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy",
                                sx: {
                                  maxLength: 200,
                                  width: 200,
                                  fontSize: '18px',  
                                },
                                InputProps: {
                                  style: {
                                    fontSize: '18px',
                                  }
                                },
                                InputLabelProps:{ 
                                  style: {
                                    fontSize: '18px', 
                                    background: '#FFFFFF'
                                  }
                                },
                              },
                            }}
                          />
                        </LocalizationProvider>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Delivery_quantity')} :</label>
                        &nbsp;&nbsp;&nbsp;&nbsp; 
                        <NumericFormat 
                          thousandSeparator={','} 
                          decimalSeparator={'.'} 
                          decimalScale= {2}
                          fixedDecimalScale= {true}
                          allowNegative= {false}
                          isAllowed={withValueCap}
                          id="delivery_quantity" 
                          name="delivery_quantity"
                          value={formForm.delivery_quantity}
                          label={errorsForm.delivery_quantity!=null?t(errorsForm.delivery_quantity):t('PlaceHolder_FORM_Delivery_quantity')}
                          placeholder={t('PlaceHolder_FORM_Delivery_quantity')}
                          inputProps={{ style: {width: i18n.language==='es'?255:351} }}
                          InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                          customInput={TextField}
                          error={Boolean(errorsForm.delivery_quantity)}
                          helperText={errorsForm.delivery_quantity ? t(errorsForm.delivery_quantity) : ""}
                          onBlur={handleBlurDataEditFormAmount}
                          onChange={handleChangeDataEditFormAmount}  
                        />
                      </div>
                    </div>

                    <div className="row p-2"> 
                      <div className="form-group">   
                        <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Accept')} :</label>
                        &nbsp;&nbsp;&nbsp;&nbsp; 
                        <TextField
                          id="accept"
                          name="accept"
                          value={ (formForm.accept === undefined || formForm.accept ===null || formForm.accept ==="")?"":formForm.accept}
                          inputProps={{ style: {width: i18n.language==='es'?213:250} }}
                          InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                          variant="outlined"
                          onBlur={handleBlurSelectAccepted}
                          onChange={handleChangeSelectAccepted}
                          helperText={errorsForm.accept!=null?t(errorsForm.accept):""}
                          select
                          SelectProps={{
                              native: true,
                              value: (formForm.accept === undefined || formForm.accept ===null || formForm.accept ==="")?"":formForm.accept
                          }}>
                          <option key={0} value=""/>
                          {textAccepted.map((option) => (
                              <option key={option.id} value={option.name}>
                                  {t(option.name)}
                              </option>
                          ))}
                        </TextField>  
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Date_Accepted')} :</label>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <DesktopDatePicker
                            id="date_accepted" 
                            name="date_accepted"
                            value={ formForm.date_accepted!== null ? new Date(formForm.date_accepted): null}
                            format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                            label={errorsForm.date_accepted!=null?t(errorsForm.date_accepted):t('PlaceHolder_FORM_Date_Accepted')}
                            onBlur={handleBlurSelectDateAccepted}
                            onChange={handleChangeSelectDateAccepted}
                            disabled={shareddate_accepted} 
                            slotProps={{
                              textField: {
                                error: Boolean(errorsForm.date_accepted),
                                helperText: errorsForm.date_accepted ? t(errorsForm.date_accepted) : "",
                                placeholder: i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy",
                                sx: {
                                  maxLength: 200,
                                  width: 200,
                                  fontSize: '18px',  
                                },
                                InputProps: {
                                  style: {
                                    fontSize: '18px',
                                  }
                                },
                                InputLabelProps:{ 
                                  style: {
                                    fontSize: '18px', 
                                    background: '#FFFFFF'
                                  }
                                },
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </div>
                    </div>
                    {reason_refund_view  && 
                      <div className="row p-2"> 
                        <div className="form-group">
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Reason_Refund')} :</label>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <TextField
                            id="reason_refund" 
                            name="reason_refund"
                            value={formForm.reason_refund}
                            inputProps={{ style: {width: i18n.language==='es'?729:716}, maxLength: 100  }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                            label={errorsForm.reason_refund!=null?t(errorsForm.reason_refund):t('PlaceHolder_FORM_Reason_Refund')}
                            error={errorsForm.reason_refund!=null}
                            placeholder={t('PlaceHolder_FORM_Reason_Refund')}
                            variant="standard"
                            onBlur={handleBlurDataEditForm}
                            onChange={handleChangeDataEditForm} 
                            disabled={!reason_refund_handle || sharedreason_refund}/>
                        </div>
                      </div>
                    }  
                    {(action_refund_view || date_refund_view) && 
                      <div className="row p-2"> 
                        {action_refund_view && 
                          <div className="form-group">
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Action_Refund')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField
                              id="action_refund" 
                              name="action_refund"
                              value={formForm.action_refund}
                              inputProps={{ style: {width: i18n.language==='es'?223:281}, maxLength: 100  }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              label={errorsForm.action_refund!=null?t(errorsForm.action_refund):t('PlaceHolder_FORM_Action_Refund')}
                              error={errorsForm.action_refund!=null}
                              placeholder={t('PlaceHolder_FORM_Action_Refund')}
                              variant="standard"
                              onBlur={handleBlurDataEditForm}
                              onChange={handleChangeDataEditForm}
                              disabled={!action_refund_handle || sharedaction_refund}
                              />
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                          </div>
                        }
                        {date_refund_view && 
                          <div className="form-group"> 
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Refund')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <DesktopDatePicker
                              id="date_refund" 
                              name="date_refund"
                              value={ formForm.date_refund!== null ? new Date(formForm.date_refund): null}
                              format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                              label={errorsForm.date_refund!=null?t(errorsForm.date_refund):t('PlaceHoldert_FORM_Refund')}
                              onBlur={handleBlurSelectDateRefund}
                              onChange={handleChangeSelectDateRefund}
                              disabled={!date_refund_handle || shareddate_refund}
                              slotProps={{
                                textField: {
                                  error: errorsForm.date_refund!=null,
                                  placeholder: i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy",
                                  sx: {
                                    maxLength: 200,
                                    width: 200,
                                    fontSize: '18px',  
                                  },
                                  InputProps: {
                                    style: {
                                      fontSize: '18px',
                                    }
                                  },
                                  InputLabelProps:{ 
                                    style: {
                                      fontSize: '18px', 
                                      background: '#FFFFFF'
                                    }
                                  },
                                },
                              }}
                            />
                          </LocalizationProvider>
                        </div>
                      }  
                    </div>
                  }
                    <div className="row p-2"> 
                      <div className="form-group">   
                        <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Observations')} :</label>
                        &nbsp;&nbsp;&nbsp;&nbsp; 
                        <TextField
                          id="observations" 
                          name="observations"
                          value={formForm.observations}
                          inputProps={{ style: {width: i18n.language==='es'?738:752}, maxLength: 250  }}
                          InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                          label={errorsForm.observations!=null?t(errorsForm.observations):t('PlaceHolder_FORM_Observations')}
                          placeholder={t('PlaceHolder_FORM_Observations')}
                          variant="standard"
                          onBlur={handleBlurDataEditForm}
                          onChange={handleChangeDataEditForm}
                          disabled={sharedobservations} />
                      </div>
                    </div> 
                    <Grid container spacing={4} justifyContent="space-around" alignItems="stretch">
                      {/* Firma Operador Traslado */}
                      <Grid item xs={4} sm={4} md={4} sx={{ margin: "auto" }} key={1}>
                        <div className="signature-card">
                          <div className={`signature-box ${sharedsignOptTras ? "signature-box--disabled" : ""}`}>
                            <SignatureCanvas
                              penColor="black"
                              ref={signDispatchedOptTrasCanvas}
                              canvasProps={{
                                width: CANVAS_SIZE,
                                height: CANVAS_SIZE,
                                style: {
                                  width: `${CANVAS_SIZE}px`,
                                  height: `${CANVAS_SIZE}px`,
                                  display: "block"
                                }
                              }}
                            /> 
                          </div>
                          <div className="signature-title">{t("Text_Signature_Opt_Tras")}</div>
                          <div className="sigblocksign-actions">
                            <Button className="sigblocksign-btn sigblocksign-btn-user"
                              onClick={() => drawPredefinedSignature()}
                            disabled={sharedsignOptTras || defaultsignature===""}
                            >
                              {t("Button_Sign_User")}
                            </Button> 
                            <Button
                              className="sigblocksign-btn sigblocksign-btn-delete"
                              disabled={sharedsignOptTras}
                              onClick={() => deleteSignature(1)}
                            >
                              {t("Button_Delete")}
                            </Button>
                          </div>   
                        </div>
                      </Grid>

                      {/* Firma Destino Traslado */}
                      <Grid item xs={4} sm={4} md={4} sx={{ margin: "auto" }} key={2}>
                        <div className="signature-card">
                          <div className={`signature-box ${sharedsignDestTras ? "signature-box--disabled" : ""}`}>
                            <SignatureCanvas
                              penColor="black"
                              ref={signDispatchedDestTrasCanvas}
                              canvasProps={{
                                width: CANVAS_SIZE,
                                height: CANVAS_SIZE,
                                style: {
                                  width: `${CANVAS_SIZE}px`,
                                  height: `${CANVAS_SIZE}px`,
                                  display: "block"
                                }
                              }}
                            />  
                          </div>
                          <div className="signature-title">{t("Text_Signature_Dest_Tras")}</div>
                          <div className="sigblocksign-actions">
                            <Button className="sigblocksign-btn sigblocksign-btn-user"
                              onClick={() => drawPredefinedSignatureDestTras()}
                              disabled={sharedsignDestTras || defaultsignature===""}
                            >
                              {t("Button_Sign_User")}
                            </Button> 
                            <Button
                              className="sigblocksign-btn sigblocksign-btn-delete"
                              onClick={() => deleteSignature(2)}
                               disabled={sharedsignDestTras}
                            >
                              {t("Button_Delete")}
                            </Button>
                          </div>     
                        </div>
                      </Grid>

                      {/* Firma Rechazo Destino */}
                      <Grid item xs={4} sm={4} md={4} sx={{ margin: "auto" }} key={3}>
                        <div className="signature-card">
                          <div className={`signature-box ${sharedsignRefund ? "signature-box--disabled" : ""}`}>
                            <SignatureCanvas
                              penColor="black"
                              ref={signDispatchedRefundCanvas}
                              canvasProps={{
                                width: CANVAS_SIZE,
                                height: CANVAS_SIZE,
                                style: {
                                  width: `${CANVAS_SIZE}px`,
                                  height: `${CANVAS_SIZE}px`,
                                  display: "block"
                                }
                              }}
                            /> 
                          </div>  
                          <div className="signature-title">{t("Text_Signature_Refund")}</div>
                          <div className="sigblocksign-actions">
                            <Button className="sigblocksign-btn sigblocksign-btn-user"
                              onClick={() => drawPredefinedSignatureRefund()}
                              disabled={sharedsignRefund || defaultsignature===""}
                              >
                              {t("Button_Sign_User")}
                            </Button> 
                            <Button
                              className="sigblocksign-btn sigblocksign-btn-delete"
                              onClick={() => deleteSignature(3)}
                              disabled={sharedsignRefund}
                            >
                              {t("Button_Delete")}
                            </Button>
                          </div>     
                        </div>
                      </Grid>
                    </Grid> 
                  </div> 
              </>:
                <LoadingNews/>
              }
            </form>
          </Box>
          <br/>
          <SearchNTFilter
            showModalNTSettings={showModalNTSettings}
            setShowModalNTSettings={setShowModalNTSettings} 
            setFormForm={setFormForm}
          />
          <FormSearchCodeLers
            showModalSearchCodeLERS={showModalSearchCodeLERS}
            setShowModalSearchCodeLERS={setShowModalSearchCodeLERS} 
            setFormForm={setFormForm}
          />
           <FormSearchDescriptions
            showModalSearchDescriptions={showModalSearchDescriptions}
            setShowModalSearchDescriptions={setShowModalSearchDescriptions} 
            setFormForm={setFormForm}
          />
         
        </div>
      //* End Page Content *//
    ) :  null }
  </>
  )    
}
